import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useDispatch } from "react-redux";
import ContactModal from "../model/ContactModal";
import { increment, decrement } from "../../Redux/Action/Action";
import Slider from "react-slick";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserAuth } from "../../context/AppContext";
import { Link } from "react-router-dom";
// import { MetaTags } from "react-meta-tags";
import DevelopmentBanImg from "../../assets/images/development-ban.jpg";
import { Helmet } from "react-helmet";

function Development() {
  const { subActive, setSubActive } = useUserAuth();
  const [commonModal, setCommonModal] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const routePath = useLocation();
  const location = useLocation();
  const path = location.pathname;
  const scrollToRef = useRef();
  const accuratePath = routePath.pathname;

  useEffect(() => {
    if (accuratePath === "/development") {
      window.scroll({
        top: 0,
        behavior: "instant",
      });
    }

    if (
      accuratePath === "/development" ||
      accuratePath === "/development/website-development" ||
      accuratePath === "/development/web-app-development" ||
      accuratePath ===
      "/web-application-development" ||
      accuratePath === "/development/mobile-app-development" ||
      accuratePath ===
      "/mobile-apps-development" ||
      accuratePath === "/development/desktop-app-development" ||
      accuratePath === "/development/customer-relationship-management" ||
      accuratePath === "/development/content-management-system"
    ) {
      setSubActive(0);
    } else if (
      accuratePath === "/development/website-development/CMS-based-websites" ||
      accuratePath ===
      "/development/web-app-development/open-Source-development" ||
      accuratePath ===
      "/development/mobile-application-development/iOS-app-development" ||
      accuratePath ===
      "/development/desktop-applications/customized-intranet-applications" ||
      accuratePath === "/development/customer-relationship-management/zoho" ||
      accuratePath ===
      "/zoho" ||
      accuratePath ===
      "/umbraco" ||
      accuratePath === "/development/content-management-system/umbraco"
    ) {
      setSubActive(1);
    } else if (
      accuratePath === "/development/website-development/dynamic-websites" ||
      accuratePath ===
      "/development/web-app-development/microsoft-technology-development" ||
      accuratePath ===
      "/development/mobile-application-development/android-app-development" ||
      accuratePath ===
      "/android-application" ||
      accuratePath ===
      "/development/desktop-applications/ERP-management-software" ||
      accuratePath ===
      "/development/customer-relationship-management/salesforce" ||
      accuratePath === "/development/content-management-system/kentico"
    ) {
      setSubActive(2);
    } else if (
      accuratePath === "/development/website-development/static-pages" ||
      accuratePath ===
      "/development/web-app-development/oracle-technology-development" ||
      accuratePath ===
      "/development/mobile-application-development/IOT-applications" ||
      accuratePath ===
      "/development/desktop-applications/industrial-automation" ||
      accuratePath ===
      "/development/customer-relationship-management/hubspot" ||
      accuratePath === "/development/content-management-system/Nop-commerce"
    ) {
      setSubActive(3);
    } else if (
      accuratePath ===
      "/development/website-development/informational-websites" ||
      accuratePath ===
      "/development/web-app-development/progressive-web-app-development" ||
      accuratePath ===
      "/development/mobile-application-development/hybrid-app-development" ||
      accuratePath ===
      "/development/desktop-applications/utility-application" ||
      accuratePath ===
      "/development/customer-relationship-management/microsoft-dynamics-365" ||
      accuratePath === "/development/content-management-system/shopify"
    ) {
      setSubActive(4);
    } else if (
      accuratePath ===
      "/development/web-app-development/ecommerce-development" ||
      accuratePath ===
      "/e-commerce-development" ||
      accuratePath ===
      "/development/mobile-application-development/embedded-app-development" ||
      accuratePath ===
      "/embedded-application" ||
      accuratePath === "/bigcommerce-website-development-services" ||
      accuratePath === "/development/content-management-system/Big-commerce"
    ) {
      setSubActive(5);
    } else if (
      accuratePath ===
      "/development/web-app-development/marketplace-development" ||
      accuratePath ===
      "/development/mobile-application-development/wearable-app-development" ||
      accuratePath === "/development/content-management-system/magento"
    ) {
      setSubActive(6);
    } else if (
      accuratePath === "/development/content-management-system/Woo-commerce"
    ) {
      setSubActive(7);
    } else if (
      accuratePath === "/development/content-management-system/wordpress" ||
      accuratePath ===
      "/wordpress"
    ) {
      setSubActive(8);
    }
    // eslint-disable-next-line
  }, [accuratePath]);

  useEffect(() => {
    var count = 0;
    var path = routePath.pathname;
    for (var i = 0; i < path.length; i++) {
      if (path[i] === "/") {
        count++;
      }
    }
    if (count > 1) {
      scrollToRef.current.scrollIntoView();
    }
  }, [routePath, subActive]);

  const settings = {
    prevArrow: (
      <button
        type="button"
        className="slick-prev"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Previous
      </button>
    ),
    nextArrow: (
      <button
        type="button"
        className="slick-next"
        onMouseOver={() => dispatch(increment())}
        onMouseLeave={() => dispatch(decrement())}
      >
        Next
      </button>
    ),
    speed: 500,
    dots: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 499,
        settings: {
          slidesToShow: 1,
          autoplay: false,
        },
      },
    ],
  };

  return (
    <>


      {/* <MetaTags>
  <meta
    id="meta-description"
    name="description"
    content="Kindlebit delivers the best website and mobile app development services, including CRM software solutions. Contact our expert development team now"
  />
</MetaTags> */}
      <Helmet>
        <title>Website Development Company | Design & Development Services</title>
        <meta
          name="keyword"
          content="website development company, web design and development, web development services, web designing company sites"
        />
        <meta
          name="description"
          content="Kindlebit specializes in website design and development services. Our web experiences are high-performing, feature-packed and digitally transformative."
        />
      </Helmet>
      <main className="inner-page" id="services-Development">
        <section className="banner dark">
          <img className="banner-img" src={DevelopmentBanImg} alt="..." />
          <div className="banner-inner container">
            <div className="banner-heading">
              <div className="sap-lg-heading">Development</div>
              <div className="text-para">
                We place reliable, cutting-edge technology at the heart of our
                creative by working with cuttingedge platforms, software, and
                analytics. For design and development that consistently delivers
                by being smart, secure, and user-centric.
              </div>
            </div>
          </div>
        </section>
        <section className="sap-card">
          <div
            className="back-blue-art"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="194.877"
              height="397.823"
              viewBox="0 0 194.877 397.823"
            >
              <g
                id="Group_67"
                data-name="Group 67"
                transform="translate(-2996.562 -104.677)"
              >
                <rect
                  id="Rectangle_90"
                  data-name="Rectangle 90"
                  width="194.877"
                  height="397.823"
                  rx="97.439"
                  transform="translate(2996.562 104.677)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_93"
                  data-name="Rectangle 93"
                  width="117.351"
                  height="318"
                  rx="58.675"
                  transform="translate(3035.325 144.589)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_94"
                  data-name="Rectangle 94"
                  width="55.803"
                  height="237"
                  rx="27.901"
                  transform="translate(3066.099 185.088)"
                  fill="#00224b"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_95"
                  data-name="Rectangle 95"
                  width="16.199"
                  height="175.098"
                  rx="8.099"
                  transform="translate(3085.901 216.039)"
                  fill="#00224b"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>

          <div
            className="back-orange-art"
            data-aos="fade-left"
            data-aos-duration="800"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="252.883"
              height="123.877"
              viewBox="0 0 252.883 123.877"
            >
              <g
                id="Group_68"
                data-name="Group 68"
                transform="translate(-4187.117 -707.061)"
              >
                <rect
                  id="Rectangle_99"
                  data-name="Rectangle 99"
                  width="123.877"
                  height="252.883"
                  rx="61.939"
                  transform="translate(4440 707.061) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_100"
                  data-name="Rectangle 100"
                  width="74.596"
                  height="202.142"
                  rx="37.298"
                  transform="translate(4414.629 731.702) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_101"
                  data-name="Rectangle 101"
                  width="35.472"
                  height="150.653"
                  rx="17.736"
                  transform="translate(4388.885 751.264) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
                <rect
                  id="Rectangle_102"
                  data-name="Rectangle 102"
                  width="10.297"
                  height="111.304"
                  rx="5.148"
                  transform="translate(4369.21 763.851) rotate(90)"
                  fill="#f38020"
                  opacity="0.05"
                />
              </g>
            </svg>
          </div>
          <div className="sap-card-inner container">
            <div className="sec-heading">
              <div className="sap-caption-head">
                <div className="sap-caption">what our services say</div>
              </div>
              <div ref={scrollToRef} className="sap-lg-heading">
                Our services
                <br />
                that we provide
              </div>
            </div>

            <Slider
              {...settings}
              className="services-slider owl-carousel owl-theme"
            >
              <Link to="/development/website-development">
                <div
                  className={
                    accuratePath === "/development/website-development" ||
                      accuratePath === "/development" ||
                      accuratePath ===
                      "/development/website-development/CMS-based-websites" ||
                      accuratePath ===
                      "/development/website-development/dynamic-websites" ||
                      accuratePath ===
                      "/development/website-development/static-pages" ||
                      accuratePath ===
                      "/development/website-development/informational-websites"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="1"
                  onClick={(e) => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="314.881"
                      height="300"
                      viewBox="0 0 314.881 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_10"
                        data-name="Group 10"
                        transform="translate(-10035.06 -7252.714)"
                      >
                        <path
                          id="Path_50"
                          data-name="Path 50"
                          d="M10273.58,7552.714c-1.4,0-2.8-.012-4.2-.024l-2.006-.016c-6.776-.04-11.186-4.21-11.512-10.884-.186-3.692-2.034-5.969-5.35-6.587a1.116,1.116,0,0,1-.208-.08c-2.925-1.583-5.464-2.64-8.334-2.64-3.015,0-5.822,1.212-8.586,3.7a5.615,5.615,0,0,1-3.776,1.263,11.146,11.146,0,0,1-7.1-2.786,117.489,117.489,0,0,1-9.517-9.457c-3.787-4.266-3.606-10.227.441-14.494,2.656-2.812,2.993-5.666,1-8.486a8.267,8.267,0,0,1-.708-1.561l-.223-.567a16.67,16.67,0,0,1-.56-1.78c-.579-2.1-1.234-4.478-3.432-5.75a9.007,9.007,0,0,0-4.547-1.042c-.8,0-1.591.058-2.351.114-.672.05-1.3.1-1.854.1-3.569,0-18.048,0-18.048,0h-7.332q-9.911,0-19.822-.023a4.149,4.149,0,0,1-3.221-1.148,3,3,0,0,1-.511-2.438c.091-.567.366-2.283,3.536-2.29l6.419-.019c3.717-.012,7.394-.024,11.071-.024,5.987,0,10.887.032,15.416.1l.26,0a6.31,6.31,0,0,0,4.892-1.746,6.565,6.565,0,0,0,1.4-5.156c-.209-2.979-.117-6.083-.027-9.085.186-6.645,4.369-10.942,10.92-11.216,3.7-.168,5.864-1.911,6.433-5.18a4.9,4.9,0,0,1,.354-.9c1.974-4.026,4.683-9.552-1.134-15.957-2.827-3.126-1.306-8.571,1.725-11.822,2.328-2.485,4.962-5.129,8.288-8.32a11.3,11.3,0,0,1,7.752-3.343,10.745,10.745,0,0,1,7.376,3.088,7.168,7.168,0,0,0,4.892,2.288,6.469,6.469,0,0,0,3.946-1.45,1.415,1.415,0,0,1,.463-.218c6.746-1.612,10-5.3,10.54-11.949.328-4.032,4.615-6.764,8.569-7.076,2.458-.194,5.014-.292,7.6-.292,1.879,0,3.814.052,5.752.155,5.991.326,9.947,4.262,10.325,10.272.251,3.987,2.237,6.415,5.746,7.031l.117.063c2.829,1.444,5.607,2.732,8.678,2.732,3.214,0,5.98-1.373,8.453-4.2a3.377,3.377,0,0,1,2.15-.556,5.847,5.847,0,0,1,.779.051,9.133,9.133,0,0,0,1.256.09c5.275,0,5.275-4.835,5.275-6.423q-.047-13.972-.036-27.922v-.814q0-12.013-.021-24.023a19.634,19.634,0,0,1,.168-2.024c.286-2.484.643-5.574-1.517-7.872a6.685,6.685,0,0,0-5.182-1.966,23.543,23.543,0,0,0-2.822.222,18.42,18.42,0,0,1-1.989.173q-39.792-.015-79.585-.02h-.915c-59.26-.011-120.536-.022-181.04-.1-1.841,0-3.93.21-5.479,1.763-1.739,1.742-1.732,4.235-1.729,5.575.108,36.313.083,73.22.059,108.912v.637c-.01,7.073,1.647,12.858,5.067,17.687,4.157,5.859,9.768,8.83,16.675,8.829h.158q7.175-.047,14.338-.041,5.805,0,11.61.012l8.575.012c4.094.007,4.137,2.162,4.15,2.87a2.535,2.535,0,0,1-.668,1.921,5.082,5.082,0,0,1-3.563,1.1h-1.047c-3.34,0-6.68-.023-10.019-.046-3.356-.022-6.71-.045-10.062-.045-4.971,0-9.061.05-12.871.158q-.409.012-.812.012c-16.859,0-25.885-15.079-26.91-25.785l-.069-.69-.132-.242,0-.073a6.386,6.386,0,0,0-.325-2.732V7282.347a6.325,6.325,0,0,0,.325-2.723c0-.038,0-.072-.006-.1l.138-.253.059-.682c1.015-10.728,10.361-25.846,27.957-25.846h.124c40.5.161,80.147.242,117.832.242,39.626,0,78.8-.09,116.426-.267h.163c16.9,0,27.185,13.415,28.608,26.667a74.192,74.192,0,0,1,.333,7.484c.016,41.585.026,85.756-.033,128.421a10.5,10.5,0,0,0,3.318,8.162c5.449,5.363,5.595,10.977.429,16.687a5.722,5.722,0,0,0-.924,6.9,60.309,60.309,0,0,1,2.953,7.13,6.11,6.11,0,0,0,6.142,4.526c6.961.338,10.976,4.6,11.016,11.683l.007,1.2c.015,3.028.028,6.108-.015,9.1a10.75,10.75,0,0,1-10.712,10.987c-3.73.077-6.042,1.9-6.689,5.258a1.945,1.945,0,0,1-.051.205c-2.8,4.952-4.607,10.427.983,16.9,2.439,2.823,1.088,8.164-1.652,11.193a126.82,126.82,0,0,1-9.063,9.1,10.492,10.492,0,0,1-7.138,2.86A11.048,11.048,0,0,1,10308,7534a6.936,6.936,0,0,0-4.771-2.287,6.114,6.114,0,0,0-3.812,1.426h0a1.267,1.267,0,0,1-.186.066c-5.123,1.313-10.454,3.819-11.163,12.447-.327,4.019-5.186,6.86-9.518,6.993C10277.064,7552.691,10275.484,7552.714,10273.58,7552.714Zm-33.818-28.994a5.74,5.74,0,0,1,2.567.99,59.028,59.028,0,0,0,14.895,6.346c4.467,1.182,4.554,1.295,4.578,6,0,.739,0,1.393-.008,1.971-.024,2.742-.041,4.72,1.484,6.26,1.389,1.4,3.133,1.515,5.1,1.515.344,0,.723,0,1.142-.008.556-.006,1.064-.011,1.629-.011l1.5,0c8.96,0,10.2-2.282,10.38-11.352.048-2.715.452-3.231,3.091-3.943a61.908,61.908,0,0,0,15.567-6.345,8.772,8.772,0,0,1,3.366-1.452c.8,0,2.265,1.359,3.295,2.381,2.949,2.928,4.574,4.541,7.156,4.541,2.6,0,4.236-1.641,7.205-4.619,6.568-6.568,6.586-8.88.129-15.461-2.277-2.325-2.331-2.807-.629-5.729a58.47,58.47,0,0,0,6.156-14.638c1.121-4.25,1.229-4.331,5.765-4.337l2.751.012c2.381,0,4.177-.113,5.625-1.577,1.561-1.575,1.539-3.591,1.51-6.379-.007-.587-.013-1.243-.011-1.984.021-9.481-1.506-11.061-10.889-11.268-2.951-.066-3.607-.587-4.387-3.484a61.482,61.482,0,0,0-6.243-15.258c-2.105-3.592-2.083-3.779.81-6.7,6.095-6.137,6.1-8.283.032-14.35-3.247-3.253-5.036-5.044-7.78-5.044-2.687,0-4.45,1.708-7.646,4.809-1.323,1.284-2.225,1.857-2.922,1.857a6.409,6.409,0,0,1-2.819-1.108,57.81,57.81,0,0,0-15.9-6.532c-3.117-.763-3.516-1.307-3.546-4.85-.083-8.778-1.618-10.321-10.266-10.321-9.209,0-10.849,1.631-10.972,10.91-.039,3.083-.448,3.612-3.369,4.353a45.217,45.217,0,0,0-12.271,4.708c-3.278,1.974-5.446,2.934-6.628,2.934-.8,0-1.615-.768-3.573-2.8-.587-.61-1.229-1.275-1.95-1.985l-.164-.17a6.259,6.259,0,0,0-4.586-2.311l-.73-.018-.669.283a13.12,13.12,0,0,0-4.628,3.733c-.405.451-.76.848-1.119,1.2-6.486,6.371-6.5,8.647-.11,15.215,2.448,2.526,2.494,2.919.709,6.014a58.269,58.269,0,0,0-6.189,14.977c-.907,3.58-1.346,3.911-5.21,3.935-8.671.042-10.2,1.6-10.2,10.392,0,9.127,1.62,10.742,10.84,10.8,3.28.018,3.745.376,4.521,3.49a57.761,57.761,0,0,0,6.129,15.015c2.048,3.539,2.009,3.852-.831,6.7-6.1,6.106-6.1,8.252-.017,14.346,3.257,3.256,5.05,5.05,7.79,5.05,2.7,0,4.46-1.721,7.653-4.845l.224-.231C10238.278,7524.226,10239.1,7523.72,10239.762,7523.72Zm-176.086-265.011c-9,0-15.441,4.023-19.7,12.3a29.12,29.12,0,0,0-3.007,13.681q0,5.178.015,10.367v.171c.021,11.357.044,23.068-.1,34.643a6.773,6.773,0,0,0,1.623,5.056c1.514,1.531,3.492,1.659,5.228,1.659,28.935-.055,58.165-.062,82.943-.062l50.209,0h132.834c.261,0,.52-.006.777-.014.218-.006.4-.011.583-.011a3.759,3.759,0,0,1,.452.02,7.332,7.332,0,0,0,.779.045c2.181,0,4.729-1.354,4.729-5.169-.028-5.665-.016-11.76-.007-16.21v-.353c.021-11.076.042-22.512-.263-33.769-.354-13.336-9.769-22.3-23.428-22.3l-98.527.006c-39.822,0-87.017-.008-135.111-.064Zm208.606,251.808a35.363,35.363,0,0,1-35.218-35.347v-.09a35.34,35.34,0,1,1,35.293,35.437Zm.2-64.672a29.07,29.07,0,0,0-29.436,29.14v.163a29.364,29.364,0,0,0,58.728.21l0-.321a29.308,29.308,0,0,0-29.064-29.191Zm-41.889-129.964c-4.261,0-7.771-.031-11.051-.1a17.852,17.852,0,0,1-8.952-32.985,18.662,18.662,0,0,1,10.119-2.793l12.678-.017q9.9-.015,19.8-.02c8.537,0,15.657.017,22.405.054,10.541.057,18.492,7.774,18.5,17.952v.1c-.05,10.037-8,17.678-18.488,17.77q-4.944.041-9.891.036-4.169,0-8.335-.012l-.5,0q-3.586-.007-7.171-.013l.018.019a17.023,17.023,0,0,0-1.7-.045q-4.367,0-8.719.029h-.245C10236.231,7315.867,10233.413,7315.881,10230.6,7315.881Zm1.185-29.906c-4.423,0-8.04.021-11.383.066-7,.1-12.272,5.21-12.27,11.886.036,6.778,5.338,11.911,12.331,11.946,8.1.04,16.838.06,26.718.06q13.951,0,27.9-.034h.653c5.313-.012,9.242-2.462,11.363-7.086a11.907,11.907,0,0,0,1.124-5.02c0-6.486-5.479-11.648-12.46-11.751-3.339-.052-6.9-.076-11.205-.076q-4.343,0-8.688.021-3.743.015-7.483.021-4.141,0-8.287-.016T10231.78,7285.975Zm-141.5,29.858a17.916,17.916,0,0,1,.108-35.828h.122a17.914,17.914,0,0,1-.06,35.828Zm.23-29.809a11.944,11.944,0,0,0-11.937,11.866,11.882,11.882,0,1,0,23.764.1,11.944,11.944,0,0,0-11.817-11.966Zm54.963,29.809a18,18,0,0,1-17.844-17.837v-.154a17.885,17.885,0,1,1,17.9,17.991Zm.043-29.81a11.918,11.918,0,0,0-11.842,11.753v.128a11.986,11.986,0,0,0,11.691,11.977h.184a12.165,12.165,0,0,0,11.941-11.759v-.2a12.007,12.007,0,0,0-11.755-11.9Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_51"
                          data-name="Path 51"
                          d="M10162.577,7438.633a2.781,2.781,0,0,1-1.845-.734c-1.391-1.221-1.308-2.992.222-4.736,4.612-5.258,8.782-9.99,13.113-14.66,2.686-2.894,2.713-5.794.079-8.618-3.565-3.823-7.05-7.78-10.418-11.607l-3.109-3.526a2.77,2.77,0,0,1-.6-3.368c.489-1.065,1.145-1.682,3.043-1.682l.269-.005c.333,0,.993.319,1.793,1.215q2.147,2.406,4.307,4.807l.252.282c4.268,4.758,8.665,9.661,12.916,14.568,2,2.306,1.953,4.894-.123,7.287-4.981,5.74-10.462,11.912-17.243,19.421A3.675,3.675,0,0,1,10162.577,7438.633Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_52"
                          data-name="Path 52"
                          d="M10092.428,7438.632a4.888,4.888,0,0,1-3.268-1.919l-3.529-3.954c-4.213-4.717-8.518-9.54-12.705-14.311-2.793-3.184-2.776-5.453.063-8.67q4.657-5.275,9.346-10.521l.709-.8q3.205-3.6,6.4-7.2c1.109-1.251,1.838-1.585,2.093-1.585l.068,0c2.468.052,2.894.941,3.2,1.59a2.905,2.905,0,0,1-.6,3.6l-2.584,2.933c-3.48,3.955-7.08,8.046-10.744,11.921-2.756,2.915-2.733,5.912.063,8.907,3.742,4,7.445,8.206,11.027,12.268l1.68,1.906a4.8,4.8,0,0,1,1.493,3.321,3.034,3.034,0,0,1-2.72,2.507Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_53"
                          data-name="Path 53"
                          d="M10121.17,7443.452a2.8,2.8,0,0,1-1.443-.467,2.5,2.5,0,0,1-1.412-3.065c2.01-8.745,3.947-16.943,5.921-25.269,2-8.447,4.139-17.448,6.332-26.461.5-2.07,1.6-3.305,2.947-3.305a3.4,3.4,0,0,1,1.14.216c1.232.439,1.888,1.051,2.01,3.139l-1.357,5.8c-.9,3.84-1.813,7.766-2.747,11.689q-3.368,14.144-6.767,28.281l-1.318,5.5c-.365,1.531-.683,2.656-1.435,3.2A3.26,3.26,0,0,1,10121.17,7443.452Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_54"
                          data-name="Path 54"
                          d="M10126.7,7491.719a3.093,3.093,0,0,1-2.133-.981,2.915,2.915,0,0,1-.859-2.039,3.091,3.091,0,0,1,5.252-1.979,2.855,2.855,0,0,1,.792,2.068,2.964,2.964,0,0,1-2.973,2.931Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Website development</div>
                </div>
              </Link>

              <Link to="/development/web-app-development">
                <div
                  className={
                    accuratePath === "/development/web-app-development" ||
                      accuratePath ===
                      "/web-application-development" ||
                      accuratePath ===
                      "/development/web-app-development/open-Source-development" ||
                      accuratePath ===
                      "/development/web-app-development/microsoft-technology-development" ||
                      accuratePath ===
                      "/development/web-app-development/oracle-technology-development" ||
                      accuratePath ===
                      "/development/web-app-development/progressive-web-app-development" ||
                      accuratePath ===
                      "/development/web-app-development/ecommerce-development" ||
                      accuratePath ===
                      "/e-commerce-development" ||
                      accuratePath ===
                      "/development/web-app-development/marketplace-development"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="2"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="312.724"
                      height="260"
                      viewBox="0 0 312.724 260"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_14"
                        data-name="Group 14"
                        transform="translate(-10487.146 -7272.714)"
                      >
                        <path
                          id="Path_73"
                          data-name="Path 73"
                          d="M10771.1,7532.692q-7.582,0-15.165-.009c-5.167-.006-5.212-2.509-5.229-3.452a2.973,2.973,0,0,1,.765-2.261c.836-.854,2.433-1.306,4.612-1.307h17.637q5.348,0,10.694-.011c5.744-.014,8.419-2.639,8.42-8.26q.016-76.577.009-153.152v-42.207h-298.666v194.114c0,7.289,2.217,9.511,9.489,9.511l110.02,0,1.627-.007c.322,0,.644,0,.965.01a5.023,5.023,0,0,1,3.563,1.28,3.11,3.11,0,0,1,.8,2.332c-.1,3.058-3.052,3.393-4.316,3.4q-15.854.023-31.71.019h-60.369q-10.783,0-21.562-.008c-9.724-.008-15.53-5.769-15.531-15.41q-.013-115.107,0-230.214c0-8.443,5.929-14.339,14.417-14.34l135.341,0,148.6.005c8.45,0,14.352,5.924,14.353,14.4q.007,114.942,0,229.884c0,9.949-5.689,15.663-15.605,15.675Q10777.68,7532.693,10771.1,7532.692Zm-268.4-252.969c-.551,0-1,.017-1.426.054-4.215.374-6.977,3.209-7.036,7.22-.09,6.113-.073,12.087-.056,18.411q.01,3.721.014,7.489v1.757h298.65v-24.646c0-7.963-2.287-10.267-10.192-10.267h-278.264c-.271,0-.544,0-.815-.009C10503.278,7279.728,10502.986,7279.723,10502.7,7279.723Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_74"
                          data-name="Path 74"
                          d="M10728.126,7532.714a3.866,3.866,0,0,1-2.761-1.343l-1.2-1.249c-3.846-4.009-7.823-8.156-11.338-12.507a6.129,6.129,0,0,1-.58-4.451,145.19,145.19,0,0,1,5.446-16.621,6.084,6.084,0,0,1,3.236-3.119,137.041,137.041,0,0,1,14.625-3.089l.623-.108c1.831-.318,4.234-1.16,3.985-4.772a24.7,24.7,0,0,1,.084-3.228c.175-2.608.356-5.3-1.1-7.253s-4.325-2.291-7.1-2.614c-1.02-.118-1.982-.231-2.816-.413-.937-.206-1.885-.366-2.8-.519a24.287,24.287,0,0,1-5.222-1.265,6.973,6.973,0,0,1-3.5-3.137c-1.507-3.783-2.773-7.769-4-11.623-.569-1.794-1.141-3.589-1.735-5.373a4.3,4.3,0,0,1,1.213-4.839c2.847-3,5.586-5.992,8.484-9.161q1.743-1.9,3.524-3.842l.975-1.059-8.973-12.335-1.3.594q-2.355,1.074-4.68,2.108c-3.7,1.655-7.2,3.22-10.714,4.961a6.67,6.67,0,0,1-2.936.809,6.05,6.05,0,0,1-3.854-1.7,134.356,134.356,0,0,0-12.636-9.205c-2.35-1.538-3.067-3.084-2.646-5.7.349-2.171.593-4.375.828-6.506.251-2.263.511-4.6.892-6.857.634-3.749-.869-5.976-4.6-6.806a56.886,56.886,0,0,1-5.506-1.629c-.865-.287-1.742-.577-2.638-.857l-1.357-.422-.7,1.239q-1.271,2.26-2.537,4.471c-2.014,3.529-3.913,6.863-5.742,10.341a5.235,5.235,0,0,1-5.276,3.2q-.4,0-.828-.028c-2.483-.165-5-.248-7.474-.248-2.52,0-5.052.086-7.526.256q-.42.029-.816.029a5.22,5.22,0,0,1-5.241-3.247c-1.78-3.406-3.654-6.695-5.638-10.179q-1.28-2.247-2.6-4.58l-.7-1.248-1.364.433q-1.334.423-2.674.833c-2.6.8-5.292,1.635-7.9,2.633-1.731.662-2.274,3.248-2.17,4.42.44,4.926.9,9.742,1.686,14.507.465,2.821-.334,4.489-2.947,6.157a124.054,124.054,0,0,0-12.357,9.052,6,6,0,0,1-3.8,1.678,6.2,6.2,0,0,1-2.716-.73c-3.523-1.726-7.037-3.325-10.757-5.017-1.58-.719-3.183-1.447-4.812-2.2l-1.308-.6-9.008,12.385.975,1.06q1.715,1.865,3.41,3.739c2.657,2.925,5.4,5.949,8.218,8.829,1.911,1.956,2.22,3.715,1.14,6.494a124.518,124.518,0,0,0-4.746,14.543c-.755,2.991-2.1,4.284-4.951,4.771-2.054.352-4.11.788-6.1,1.209-2.536.537-5.159,1.093-7.734,1.462-3.186.454-4.593,2.268-4.18,5.388a4.106,4.106,0,0,1,0,.609c-.006.16-.011.319-.011.477,0,9.164.636,9.927,9.753,11.658,1.516.286,2.983.592,4.451.9,1.646.343,3.294.686,4.948.993a3.781,3.781,0,0,1,3.367,3.085c.4,1.565.827,3.124,1.257,4.681.464,1.689.942,3.435,1.375,5.152.577,2.3-.3,4.154-2.241,4.711a3.576,3.576,0,0,1-.985.144,3.778,3.778,0,0,1-3.387-2.666c-.565-8.4-7-10.111-12.551-10.655a59.421,59.421,0,0,1-7.5-1.4c-.766-.177-1.53-.353-2.295-.52-2.206-.483-3.194-1.673-3.2-3.857-.021-6.081-.036-13.26,0-20.4.013-2.255,1.06-3.421,3.5-3.9,1.771-.349,3.538-.719,5.3-1.09,3.422-.716,6.961-1.456,10.447-2.023a5.331,5.331,0,0,0,4.843-4.6l.081-.373a18.262,18.262,0,0,1,1.5-4.786c2.8-5.066.237-8.329-1.938-10.343-2.546-2.359-4.932-5.046-7.238-7.645q-1.042-1.174-2.089-2.343c-1.9-2.1-1.971-3.456-.308-5.785,4.214-5.894,7.943-11.025,11.4-15.684,1.364-1.838,2.262-2.091,3.031-2.091a6.642,6.642,0,0,1,2.584.7c1.886.841,3.759,1.711,5.633,2.581,3.054,1.417,6.213,2.883,9.388,4.205a4.723,4.723,0,0,0,1.827.334,6.905,6.905,0,0,0,3.433-.919,40.549,40.549,0,0,0,3.625-2.577,36.141,36.141,0,0,1,3.333-2.376,5.451,5.451,0,0,0,2.816-6.06c-.716-5.07-1.338-10.1-1.847-14.96-.417-3.975.02-4.635,3.892-5.893l5.858-1.905q5.351-1.741,10.708-3.475a11.43,11.43,0,0,1,3.259-.691c1.038,0,1.914.252,3.748,3.514q1.043,1.855,2.068,3.723c1.731,3.134,3.521,6.375,5.44,9.491a6.9,6.9,0,0,0,4.436,2.611,6.989,6.989,0,0,0,1.34.119c.5,0,.975-.039,1.437-.077.385-.033.769-.066,1.146-.066a3.508,3.508,0,0,1,.663.053,14.813,14.813,0,0,0,2.8.289c4.4,0,7.48-2.367,9.408-7.235a48.017,48.017,0,0,1,3.825-7.146c.545-.9,1.09-1.792,1.611-2.7,1.271-2.2,2.254-2.647,3.34-2.647a6.831,6.831,0,0,1,2,.366c4.283,1.337,8.624,2.766,12.82,4.148q2.959.975,5.917,1.941c2.36.768,3.238,2.166,2.938,4.675q-.249,2.069-.49,4.136c-.444,3.78-.9,7.688-1.424,11.516-.174,1.277-.634,4.669,3.072,6.4a9.11,9.11,0,0,1,2.908,2.038c2.2,2.461,4.529,3.656,7.134,3.656a11.872,11.872,0,0,0,6.225-2.072,54.858,54.858,0,0,1,7.492-3.633c1.006-.427,2.01-.855,3-1.3a7.124,7.124,0,0,1,2.76-.769c.775,0,1.688.265,3.115,2.188,3.637,4.9,7.308,9.94,11.225,15.408,1.87,2.611,1.775,3.786-.507,6.287l-.573.628c-3.3,3.614-6.705,7.351-10.149,10.917a5,5,0,0,0-1.234,5.906c.538,1.324.968,2.687,1.423,4.128.475,1.5.964,3.056,1.59,4.567a6.077,6.077,0,0,0,3.778,3.352c3.478.816,7.025,1.52,10.457,2.2,1.9.376,3.791.752,5.682,1.148,3.038.637,3.784,1.55,3.8,4.657.031,5.645.032,11.6,0,18.754-.016,3.387-.674,4.209-3.914,4.89-1.785.374-3.574.728-5.363,1.083-3.433.682-6.983,1.386-10.459,2.224a6.793,6.793,0,0,0-3.908,3.385,12.086,12.086,0,0,0-.952,2.8,8.276,8.276,0,0,1-.7,2.087c-2.8,4.8-1.893,9.015,2.78,12.884a38.582,38.582,0,0,1,4.789,5.082c.343.408.684.816,1.027,1.219a3.509,3.509,0,0,1,.023,5A3.384,3.384,0,0,1,10728.126,7532.714Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_75"
                          data-name="Path 75"
                          d="M10644.285,7532.667c-2.631-.038-4.226-1.322-4.263-3.435-.04-2.161,1.492-3.492,4.1-3.563a43.975,43.975,0,0,0,39.918-60.779c-6.753-16.243-22.917-27.156-40.223-27.156a39.561,39.561,0,0,0-4.9.305c-20.215,2.538-35.795,17.372-38.768,36.911a44,44,0,0,0,5.993,29.9,10.164,10.164,0,0,1,1.454,3.521,2.777,2.777,0,0,1-2.094,3.2,4.528,4.528,0,0,1-1.453.265,3.35,3.35,0,0,1-2.841-1.735,49.308,49.308,0,0,1-7.935-19.907,50.934,50.934,0,0,1,50.678-59.378c.259,0,.519,0,.779.006,27.445.388,49.752,23.265,49.724,51a51.148,51.148,0,0,1-47.356,50.765c-.795.056-1.593.085-2.37.085Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_76"
                          data-name="Path 76"
                          d="M10543.369,7364.055l-17.463.006q-6.417,0-12.835-.012c-2.2,0-4.812-.616-4.814-3.5s2.611-3.5,4.8-3.507q15.151-.011,30.3-.011t30.3.011c2.194,0,4.811.611,4.813,3.5s-2.611,3.506-4.808,3.511q-6.416.014-12.834.012Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_77"
                          data-name="Path 77"
                          d="M10527.573,7385.148q-7.408,0-14.815-.025c-1.676,0-4.489-.467-4.5-3.491s2.8-3.5,4.471-3.511c2.008-.018,4.015-.022,6.021-.022l9.115.011,8.754-.011q2.861,0,5.722.02c1.68.014,4.5.485,4.513,3.488a3.093,3.093,0,0,1-1.043,2.487,5.229,5.229,0,0,1-3.423,1.028Q10534.981,7385.149,10527.573,7385.148Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_78"
                          data-name="Path 78"
                          d="M10511.641,7300.794a3.489,3.489,0,0,1,.1-6.977l.1,0a3.543,3.543,0,0,1,3.391,3.584,3.566,3.566,0,0,1-3.487,3.393Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_79"
                          data-name="Path 79"
                          d="M10532.82,7300.795a3.489,3.489,0,0,1-.085-6.976h.09a3.489,3.489,0,0,1,.085,6.976Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_80"
                          data-name="Path 80"
                          d="M10553.9,7300.795a3.489,3.489,0,0,1-.085-6.976h.089a3.557,3.557,0,0,1,3.486,3.4,3.437,3.437,0,0,1-.975,2.471,3.473,3.473,0,0,1-2.427,1.107Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">Web application development</div>
                </div>
              </Link>

              <Link to="/development/mobile-app-development">
                <div
                  className={
                    accuratePath === "/development/mobile-app-development" ||
                      accuratePath ===
                      "/mobile-apps-development" ||
                      accuratePath ===
                      "/development/mobile-application-development/iOS-app-development" ||
                      accuratePath ===
                      "/development/mobile-application-development/android-app-development" ||
                      accuratePath ===
                      "/android-application" ||
                      accuratePath ===
                      "/development/mobile-application-development/IOT-applications" ||
                      accuratePath ===
                      "/development/mobile-application-development/hybrid-app-development" ||
                      accuratePath ===
                      "/development/mobile-application-development/embedded-app-development" ||
                      accuratePath ===
                      "/embedded-application" ||
                      accuratePath ===
                      "/development/mobile-application-development/wearable-app-development"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="3"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="222.008"
                      height="300"
                      viewBox="0 0 222.008 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_13"
                        data-name="Group 13"
                        transform="translate(-10960.524 -7252.714)"
                      >
                        <path
                          id="Path_61"
                          data-name="Path 61"
                          d="M11004.349,7552.708c-14.668,0-24.152-9.437-24.163-24.033q-.013-20.392,0-40.784l0-23.45h-14.72c-4.382-.006-4.935-.546-4.936-4.818l0-112.368q0-17.967,0-35.934c0-4.031.629-4.641,4.794-4.654q5.988-.02,11.979-.054a2.87,2.87,0,0,0,1.236-.319c.091-.041.206-.094.358-.154l1.286-.505V7291.91l-.007-5.023c-.007-3.733-.014-7.467.016-11.2.1-13.282,9.814-22.932,23.095-22.946q28.334-.03,56.677-.027,36.914,0,73.821.031l2.636,0a47.678,47.678,0,0,1,8.025.5,22.009,22.009,0,0,1,18.394,21.7c.086,6.006.068,12.124.049,18.04q-.012,3.987-.015,7.975v5.714l10.194,0c1.719,0,3.425,0,5.132.009,3.557.015,4.325.76,4.326,4.2q.015,74.61,0,149.221c0,3.6-.757,4.336-4.492,4.347-1.658,0-3.318.007-5,.007l-10.166,0,0,23.313q0,20.393,0,40.783c-.01,14.682-9.562,24.169-24.335,24.172q-33.548.006-67.093,0T11004.349,7552.708Zm135.223-5.746c.6,0,1.2-.01,1.8-.048,8.5-.538,15.363-7.391,15.624-15.6.186-5.852.143-11.826.1-17.6-.019-2.579-.038-5.173-.038-7.786V7503.9h-171.1v24.29c0,12.1,6.724,18.771,18.918,18.772h133.3Zm-153.366-49.2h170.751v-33.111h-170.751Zm-19.687-39.317h210.074V7351.787h-210.074Zm-.085-112.768h210.175v-33.091h-210.175Zm105.02-87.205q-33.977,0-67.951.015c-10.274,0-17.484,7.136-17.534,17.343-.036,7.489-.021,15.1-.007,22.457l.007,3.9a15.432,15.432,0,0,0,.144,1.826c.028.235.058.473.081.713l.174,1.835h170.083l.362-1.569c.039-.168.073-.295.1-.4a3.476,3.476,0,0,0,.155-.964l.015-7.1c.016-6.824.032-13.648.008-20.472-.037-10.505-7.118-17.566-17.621-17.57Q11105.461,7258.474,11071.452,7258.473Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_62"
                          data-name="Path 62"
                          d="M11056.774,7439.966a2.709,2.709,0,0,1-1.7-.679c-1.144-.929-1.587-1.967-.479-4.529q6.7-15.478,13.341-30.983l7.912-18.427q3.8-8.855,7.612-17.7c.816-1.891,1.877-2.11,2.6-2.11a3.818,3.818,0,0,1,.74.078c1.069.21,2.087.719,2.358,2.925-.021.073-.042.147-.064.224a11.9,11.9,0,0,1-.48,1.48c-8.857,20.653-18.9,44.062-28.839,67.123C11059.075,7438.994,11057.952,7439.966,11056.774,7439.966Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_63"
                          data-name="Path 63"
                          d="M11108.168,7430.1a2.527,2.527,0,0,1-1.764-.824,2.469,2.469,0,0,1-.893-1.763,5.238,5.238,0,0,1,1.855-3.324c4.575-4.57,9.161-9.13,13.937-13.879l7.882-7.841-1.53-1.435c-.884-.829-1.745-1.629-2.589-2.412-1.818-1.688-3.536-3.283-5.207-4.92-2.948-2.889-5.918-5.864-8.789-8.742l-3.142-3.146c-3.52-3.517-2.3-4.741-1.5-5.551a2.357,2.357,0,0,1,1.717-.888c.686,0,1.91.4,3.849,2.338l2.64,2.631q9.647,9.613,19.276,19.242c2.656,2.662,2.659,3.6.018,6.241q-11.26,11.281-22.565,22.517A4.983,4.983,0,0,1,11108.168,7430.1Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_64"
                          data-name="Path 64"
                          d="M11034.648,7430.093a3.18,3.18,0,0,1-2.19-1.036c-8.075-7.937-16.237-16.082-24.259-24.207-1.436-1.455-1.441-2.8-.017-4.247,7.865-7.966,16.026-16.112,24.258-24.21a3.214,3.214,0,0,1,2.212-1.051,2.8,2.8,0,0,1,2.007.953c1.674,1.738.525,3.42-.308,4.267-4.093,4.162-8.3,8.353-12.375,12.406q-2.9,2.888-5.8,5.779c-.528.528-1.041,1.074-1.642,1.714l-.972,1.033-1.392,1.464,1.459,1.4q.829.793,1.632,1.55c1.125,1.066,2.212,2.1,3.273,3.15l2.767,2.747c4.289,4.258,8.726,8.66,13.021,13.045,1.021,1.044,1.911,2.634.346,4.279A2.808,2.808,0,0,1,11034.648,7430.093Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_65"
                          data-name="Path 65"
                          d="M11071.523,7278.1q-9.363,0-18.729-.021c-1.416,0-3.788-.38-3.786-2.87,0-2.347,2.066-2.852,3.8-2.862q3.825-.023,7.651-.019l11.07.009,11.07-.009q3.825,0,7.649.019c1.419.008,3.8.391,3.8,2.866s-2.378,2.863-3.795,2.866Q11080.886,7278.1,11071.523,7278.1Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_66"
                          data-name="Path 66"
                          d="M11110.837,7278.069a2.853,2.853,0,0,1-.045-5.706h0a2.92,2.92,0,0,1,2.911,2.8,2.808,2.808,0,0,1-.817,2.011,2.845,2.845,0,0,1-2,.891Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_67"
                          data-name="Path 67"
                          d="M11120.651,7332.011a2.853,2.853,0,0,1,.016-5.705,2.859,2.859,0,0,1,2.03.864,2.815,2.815,0,0,1,.835,2,2.9,2.9,0,0,1-2.86,2.836Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_68"
                          data-name="Path 68"
                          d="M11140.32,7332.011a2.9,2.9,0,0,1-2.854-2.86,2.894,2.894,0,0,1,2.858-2.845,2.848,2.848,0,0,1,2.02.854,2.818,2.818,0,0,1,.846,2,2.9,2.9,0,0,1-2.862,2.849Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_69"
                          data-name="Path 69"
                          d="M11159.981,7332.012a2.853,2.853,0,0,1-.055-5.706h0a2.922,2.922,0,0,1,2.919,2.793,2.811,2.811,0,0,1-.81,2.014,2.847,2.847,0,0,1-2,.9Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_70"
                          data-name="Path 70"
                          d="M11071.465,7537.986a12.637,12.637,0,0,1-8.915-21.6,12.588,12.588,0,0,1,8.972-3.737,12.715,12.715,0,0,1,12.7,12.557,12.749,12.749,0,0,1-12.735,12.777Zm.07-19.581a6.95,6.95,0,0,0-6.924,7.093,6.919,6.919,0,1,0,7.055-7.092Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_71"
                          data-name="Path 71"
                          d="M11016.446,7528.211c-1.174,0-2.349-.01-3.521-.044-1.992-.057-3.229-1.15-3.229-2.852,0-1.732,1.221-2.823,3.189-2.847q4.761-.058,9.524-.058,4.731,0,9.463.057c1.974.024,3.2,1.114,3.2,2.844,0,1.707-1.234,2.8-3.227,2.855-1.261.034-2.524.045-3.788.045-.992,0-1.985-.007-2.978-.013s-2-.013-3-.013c-.944,0-1.888.007-2.831.013S11017.38,7528.211,11016.446,7528.211Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_72"
                          data-name="Path 72"
                          d="M11120.666,7528.222q-4.746,0-9.493-.061c-1.971-.024-3.192-1.117-3.191-2.851s1.208-2.793,3.226-2.847c1.268-.033,2.536-.043,3.8-.043.99,0,1.981.006,2.972.012s2,.012,3,.012q1.411,0,2.822-.012c.933-.006,1.864-.012,2.8-.012,1.18,0,2.358.01,3.537.042,1.991.057,3.228,1.148,3.227,2.852,0,1.732-1.228,2.824-3.2,2.847Q11125.413,7528.223,11120.666,7528.222Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">
                    Mobile Application development
                  </div>
                </div>
              </Link>

              <Link to="/development/desktop-app-development">
                <div
                  className={
                    accuratePath === "/development/desktop-app-development" ||
                      accuratePath ===
                      "/development/desktop-applications/customized-intranet-applications" ||
                      accuratePath ===
                      "/development/desktop-applications/ERP-management-software" ||
                      accuratePath ===
                      "/development/desktop-applications/industrial-automation" ||
                      accuratePath ===
                      "/development/desktop-applications/utility-application"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="4"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="300.515"
                      height="300"
                      viewBox="0 0 300.515 300"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_12"
                        data-name="Group 12"
                        transform="translate(-11356.333 -7252.714)"
                      >
                        <path
                          id="Path_56"
                          data-name="Path 56"
                          d="M11516.864,7552.714c-25.045,0-48.283-.025-71.041-.078a14.459,14.459,0,0,1-5.966-1.406,12.428,12.428,0,0,1-6.635-13.9,12.674,12.674,0,0,1,11.895-9.972c.354-.022.73-.025,1.114-.029,1.647-.018,3.514-.038,4.888-1.19,6.489-5.444,10.3-12.41,11.649-21.295l.354-2.332-54.169,0q-18.814,0-37.627-.006c-8.061,0-12.056-2.857-14.742-10.531a2.514,2.514,0,0,0-.252-.516V7298.625c2.624-7.23,7.652-10.459,16.256-10.459q.458,0,.928.011c6.265.16,13.092.237,20.87.237,7.274,0,14.665-.066,21.813-.131l7.867-.067a9.686,9.686,0,0,0,5.924-2.366c2.239-1.968,4.335-4.113,6.362-6.186.867-.888,1.734-1.775,2.613-2.649,2.609-2.6,4.836-3.8,7.008-3.8,1.864,0,3.9.839,6.418,2.638.841.6,1.689,1.188,2.54,1.775,1.948,1.347,3.787,2.618,5.523,4.051a6.651,6.651,0,0,0,4.331,1.774h0a7.87,7.87,0,0,0,3.661-1.039,87.148,87.148,0,0,1,12-5.033c2.379-.814,4.942-2.025,5.222-6.1a35.179,35.179,0,0,1,.718-4.51,42.508,42.508,0,0,0,.747-4.5c.473-4.97,2.61-8.014,6.724-9.551h25.475c4.11,1.5,6.181,4.47,6.7,9.6a83.576,83.576,0,0,0,1.815,10.49,6.354,6.354,0,0,0,3.322,3.968c5.128,2.273,10.15,4.326,14.924,6.1a6.036,6.036,0,0,0,2.068.343,6.423,6.423,0,0,0,3.358-.884c2.19-1.394,4.311-2.922,6.359-4.4,1.3-.939,2.606-1.878,3.928-2.786a9.531,9.531,0,0,1,5.354-1.892,8.792,8.792,0,0,1,6.1,2.833c1.308,1.263,2.584,2.557,3.859,3.852,1.972,2,4.01,4.067,6.146,6a9.123,9.123,0,0,0,5.7,2.291c12.021.081,24.238.083,36.055.084q8.445,0,16.887.01a21.649,21.649,0,0,1,4.842.363c6.32,1.508,10.093,6.7,10.094,13.884q.01,74.787,0,149.573v34.8c0,10.485-5.069,15.583-15.5,15.585h-91.29l.347,2.325a35.191,35.191,0,0,0,8.521,18.4,11.032,11.032,0,0,0,8.857,4.221,12.336,12.336,0,0,1,8.837,3.626,12.778,12.778,0,0,1,3.547,9.231,12.408,12.408,0,0,1-12.728,12.359Q11542.152,7552.712,11516.864,7552.714Zm-70.019-20.3c-.464,0-.927.011-1.387.047a7.562,7.562,0,0,0-.363,15.1,15.156,15.156,0,0,0,1.876.1l1.346-.01,46.235,0q35.167,0,70.329-.01h.184a18.294,18.294,0,0,0,4.1-.322,7.281,7.281,0,0,0,5.885-7.22,7.527,7.527,0,0,0-6.288-7.516,13.211,13.211,0,0,0-2.295-.165l-1.317.01c-11.715,0-78.007,0-78.007,0h-38.855Zm13.358-5.32h92.764l-9.4-24.445h-73.962Zm-97.744-47.984c0,1.138-.014,2.249-.029,3.337-.033,2.563-.066,4.982.089,7.445a6.638,6.638,0,0,0,5.812,6.282,21.091,21.091,0,0,0,3.6.223q65.609.006,131.231.007,69.111,0,138.208-.008a20.252,20.252,0,0,0,3.609-.253,6.5,6.5,0,0,0,5.646-6.071c.171-2.538.136-5.015.1-7.637-.016-1.092-.031-2.2-.031-3.325v-2.027h-242.835c-.286,0-1.391.017-1.655.017-.381,0-.761-.008-1.141-.042a2.956,2.956,0,0,1-2.973-3.024,2.919,2.919,0,0,1,2.95-3.006c.383-.031.767-.039,1.149-.039.268,0,1.374.016,1.66.016h242.717l.094-1.929.051-.942c.032-.547.054-.961.054-1.374q.006-82.08,0-164.161c0-5.51-2.666-8.192-8.146-8.2q-10.421-.015-20.843-.013c-7.595,0-26.745.01-26.745.01-.522,0-1.048.042-1.571.086-.2.018-.409.036-.614.05l-5.372.357,3.465,2.655-.737,1.308c-1.2,2.127-2.441,4.326-3.751,6.4-.7,1.107-1.478,2.164-2.3,3.284-.952,1.295-1.938,2.636-2.8,4.074a6.36,6.36,0,0,0-.4,5.14c.971,2.531,2.03,5.059,3.056,7.5,1,2.393,2.041,4.867,2.982,7.316a5.117,5.117,0,0,0,4.506,3.631c3.779.52,7.841,1.2,12.78,2.152a7.876,7.876,0,0,1,6.813,8.014c.089,6.874.092,14.161.008,21.659-.05,4.4-2.37,7.2-6.712,8.108-3.787.792-7.956,1.5-12.745,2.178a5.351,5.351,0,0,0-4.747,3.819c-.9,2.4-1.9,4.817-2.877,7.159-1,2.414-2.039,4.91-2.975,7.417a6.7,6.7,0,0,0,.479,5.415c1.4,2.21,2.938,4.349,4.424,6.417.928,1.288,1.854,2.576,2.749,3.885,2.921,4.265,2.594,7.966-1.028,11.65-4.5,4.58-9.17,9.25-14.276,14.277-2.064,2.033-4.081,3.02-6.165,3.02a10.167,10.167,0,0,1-5.7-2.14c-1.227-.86-2.441-1.738-3.655-2.614-2.134-1.541-4.339-3.136-6.6-4.614a5.652,5.652,0,0,0-3.022-.815,5.358,5.358,0,0,0-1.931.337c-5.223,2.048-10.309,4.2-15.113,6.379a6.329,6.329,0,0,0-3.323,3.977c-.532,2.441-.952,4.922-1.358,7.321-.326,1.928-.664,3.923-1.055,5.856-.853,4.228-3.629,6.6-7.814,6.684-3.7.073-7.4.11-11,.11-3.771,0-7.545-.041-11.214-.121-4.141-.09-6.885-2.5-7.728-6.778-.93-4.723-1.654-8.7-2.165-12.744-.369-2.918-2.1-3.965-3.911-4.663-2.318-.892-4.662-1.867-6.93-2.809-2.487-1.033-5.06-2.1-7.636-3.08a5.982,5.982,0,0,0-2.1-.356,5.851,5.851,0,0,0-3.065.8c-2.166,1.392-4.276,2.9-6.317,4.364-1.4,1-2.793,2-4.212,2.966a9.7,9.7,0,0,1-5.386,1.93,8.713,8.713,0,0,1-6.038-2.885c-4.466-4.372-9.2-9.109-14.486-14.48-3.606-3.665-3.9-7.364-.928-11.638,2.587-3.722,4.9-6.94,7.07-9.838a5.4,5.4,0,0,0,.638-6.063c-1.116-2.412-2.154-4.932-3.158-7.369-.957-2.321-1.946-4.722-3.014-7.061a6.721,6.721,0,0,0-4.2-3.509c-2.329-.518-4.7-.91-6.987-1.288-2.037-.337-4.144-.686-6.174-1.116-4.285-.91-6.574-3.74-6.619-8.183-.073-7.322-.071-14.512.006-21.368.05-4.52,2.6-7.452,7.188-8.255l1.781-.314c3.328-.589,6.771-1.2,10.152-1.644a5.87,5.87,0,0,0,5.277-4.5l.033-.1a61.014,61.014,0,0,1,4.413-11.078c2.221-3.929,1.976-7.074-.847-10.854-.637-.852-1.308-1.689-1.982-2.529-2.725-3.394-5.3-6.6-5.758-11.09l-.187-1.82-50.813,0c-6.429,0-8.934,2.5-8.934,8.911,0,44.986,0,167.7,0,167.7h6.63c1.4,0,6.978-.016,8.372-.016,2.929,0,5.187.018,7.322.058a3.006,3.006,0,0,1,3.073,2.891,3.146,3.146,0,0,1-3.131,3.123c-.421.032-.844.04-1.266.04-.3,0-1.535-.017-1.853-.017h-19.1Zm147.54-23.4c1.8,0,3.6,0,5.4.025h.1a4.015,4.015,0,0,0,4.426-3.886c.323-2.439.741-4.926,1.145-7.331.244-1.451.486-2.9.714-4.354.652-4.194,2.82-6.682,7.026-8.07a102.177,102.177,0,0,0,14.515-6.017,11.9,11.9,0,0,1,5.416-1.5,9.741,9.741,0,0,1,5.986,2.273c2.566,1.958,5.24,3.837,7.6,5.495.993.7,1.948,1.368,2.844,2.008l1.4,1,18.07-18.076-3.395-4.759c-1.874-2.624-3.835-5.369-5.778-8.125-2.021-2.864-2.218-5.707-.636-9.216,2.328-5.164,4.42-10.338,6.845-16.516,1.362-3.468,3.521-5.343,6.795-5.9l16.394-2.814v-25.331l-5.912-.981c-3.252-.543-6.46-1.077-9.672-1.589-3.99-.636-6.388-2.684-7.774-6.637a145.4,145.4,0,0,0-6.341-15.259c-1.966-4.053-1.728-7.345.772-10.675,1.964-2.617,3.826-5.261,5.628-7.819.764-1.084,1.51-2.144,2.238-3.165l1-1.407-18.144-17.9-1.388.988c-1.037.74-2.106,1.5-3.2,2.266-2.568,1.814-5.224,3.691-7.861,5.637a9.058,9.058,0,0,1-5.463,2,11.089,11.089,0,0,1-4.941-1.324,97.235,97.235,0,0,0-14.228-5.967c-4.97-1.542-7.344-4.3-7.937-9.21-.365-3.021-.917-6.065-1.453-9.008-.243-1.343-.49-2.7-.723-4.068l-.285-1.688-10.732-.01c-3.282,0-7.177.01-11.17.094a4.715,4.715,0,0,0-3.874,3.465c-.845,4.126-1.476,8.3-1.982,11.835-.622,4.336-2.812,6.915-7.1,8.36a104.889,104.889,0,0,0-14.515,5.986,11.789,11.789,0,0,1-5.372,1.5,9.718,9.718,0,0,1-6-2.306c-2.531-1.949-5.123-3.763-7.63-5.518-1.072-.751-2.124-1.487-3.143-2.215l-1.4-1-17.977,17.979,1,1.4q1.146,1.608,2.318,3.272c1.825,2.586,3.714,5.26,5.668,7.888,2.444,3.285,2.7,6.5.815,10.432a143.64,143.64,0,0,0-6.354,15.252c-1.429,4.142-3.956,6.265-8.2,6.886-3.136.458-6.3,1.015-9.36,1.554q-2.073.363-4.154.722l-1.687.287V7369.9s4.652.809,6.115,1.067c3.358.59,6.528,1.147,9.778,1.671,3.738.6,6.029,2.642,7.432,6.617a122.5,122.5,0,0,0,6.1,14.757c2.229,4.382,2,7.794-.759,11.406-1.938,2.538-3.765,5.137-5.531,7.651-.755,1.077-1.5,2.137-2.235,3.169l-1,1.4,17.948,17.975s3.609-2.565,4.735-3.361c2.649-1.872,5.387-3.807,8.081-5.788a8.9,8.9,0,0,1,5.369-1.932,11.283,11.283,0,0,1,4.831,1.235A137.892,137.892,0,0,0,11484.2,7432c4.4,1.477,6.64,4.114,7.255,8.549.443,3.207,1.068,7.419,1.963,11.566a4.95,4.95,0,0,0,4.113,3.506c3.188.086,6.381.093,9.124.093Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_57"
                          data-name="Path 57"
                          d="M11506.614,7421.211a63.966,63.966,0,0,1-.118-127.932h.146a63.966,63.966,0,0,1,.054,127.932Zm-.049-121.832a58.026,58.026,0,1,0,40.972,17.049,57.356,57.356,0,0,0-40.875-17.049h-.1Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_58"
                          data-name="Path 58"
                          d="M11486.1,7380.625a2.753,2.753,0,0,1-1.921-.913c-7.593-7.469-14.252-14.133-20.356-20.371a2.609,2.609,0,0,1-.009-4.1c6.438-6.592,13.288-13.441,20.358-20.359a2.874,2.874,0,0,1,2.04-.864,3.008,3.008,0,0,1,2.1.878,2.945,2.945,0,0,1-.033,4.334c-3.668,3.806-7.492,7.6-11.191,11.267l-2.414,2.4c-.548.546-1.169,1.074-1.889,1.686-.383.325-.792.672-1.232,1.057l-1.637,1.434,5.682,5.629c4.1,4.057,8.008,7.928,11.89,11.83a6.686,6.686,0,0,1,1.541,2.049,2.676,2.676,0,0,1-1.135,3.422A3.3,3.3,0,0,1,11486.1,7380.625Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_59"
                          data-name="Path 59"
                          d="M11526.706,7380.652a2.718,2.718,0,0,1-1.9-.9,2.632,2.632,0,0,1-.895-1.892,4.927,4.927,0,0,1,1.7-3.271c3.661-3.66,7.342-7.3,11.113-11.031l6.366-6.3-5.5-5.434c-3.725-3.677-7.349-7.253-10.969-10.834l-.387-.38a17.809,17.809,0,0,1-1.5-1.588,2.97,2.97,0,0,1,4.073-4.307,37.136,37.136,0,0,1,3.063,2.905c.352.36.705.72,1.062,1.075l3.213,3.2q6.179,6.149,12.323,12.329c2.4,2.425,2.4,3.671.025,6.064-6.561,6.6-12.674,12.71-18.689,18.684A4.783,4.783,0,0,1,11526.706,7380.652Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_60"
                          data-name="Path 60"
                          d="M11501.628,7380.644a3.065,3.065,0,0,1-2.4-1.146,3.945,3.945,0,0,1-.5-3.352q2.925-11.838,5.9-23.664l2.437-9.723c.17-.681.332-1.365.494-2.05.344-1.454.668-2.828,1.078-4.187a3.035,3.035,0,0,1,2.913-2.438,3.693,3.693,0,0,1,.856.1,2.876,2.876,0,0,1,1.795,1.307,3.228,3.228,0,0,1,.335,2.471c-3.334,13.557-6.719,27-9.992,40A3.13,3.13,0,0,1,11501.628,7380.644Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">
                    Desktop Application development
                  </div>
                </div>
              </Link>

              <Link to="/development/customer-relationship-management">
                <div
                  className={
                    accuratePath ===
                      "/development/customer-relationship-management" ||
                      accuratePath ===
                      "/development/customer-relationship-management/zoho" ||
                      accuratePath ===
                      "/zoho" ||
                      accuratePath ===
                      "/development/customer-relationship-management/salesforce" ||
                      accuratePath ===
                      "/development/customer-relationship-management/hubspot" ||
                      accuratePath ===
                      "/development/customer-relationship-management/microsoft-dynamics-365"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="5"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="353.858"
                      height="258"
                      viewBox="0 0 353.858 258"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_18"
                        data-name="Group 18"
                        transform="translate(-11775.937 -7273.714)"
                      >
                        <path
                          id="Path_88"
                          data-name="Path 88"
                          d="M11799.681,7531.714c-10.63,0-17.5-3.842-21.636-12.092a29.424,29.424,0,0,1-1.54-4.071c-.194-.591-.376-1.15-.568-1.7V7291.467c2.33-8.124,5.821-12.791,11.31-15.121a30.182,30.182,0,0,1,11.415-2.509c57.552-.083,118.662-.123,186.823-.123q60.832,0,121.646.038c13.973.007,22.655,8.869,22.657,23.127q.015,105.825,0,211.652c0,14.454-8.605,23.1-23.014,23.139q-15.667.04-31.339.035c-7.527,0-37.631-.016-45.158-.016l-112.149-.006q-59.21,0-118.418.031Zm22.046-252.244q-11.262,0-22.521.014c-11.473.016-17.537,6.1-17.538,17.6q-.006,105.623,0,211.241c0,11.5,6.066,17.582,17.542,17.6q10.975.017,21.95.014,14.021,0,28.044-.012l4.392,0c.852,0,1.651-.056,2.5-.117.433-.031.8-.057,1.181-.079l2.6-.146V7279.476Zm44.3,246.191,2.634.118c.351.015,1.175.06,1.175.06.8.045,1.55.087,2.312.087,0,0,82.859.008,120.942.008q56.886,0,113.763-.014c11.094,0,17.2-6.122,17.2-17.229q.012-105.969-.007-211.937a24.734,24.734,0,0,0-.37-5.1c-1.162-5.555-5.141-12.175-17.493-12.176-42.184,0-233.652,0-233.652,0h-6.506Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_89"
                          data-name="Path 89"
                          d="M12096.854,7441.472c-2.058,0-2.691-1.678-2.86-3.087-.4-3.333-.715-6.733-1.02-10.022l-.035-.37c-.152-1.636-.3-3.272-.469-4.906q-.718-7.167-1.455-14.334l-.775-7.592-4.867-.751-3.271,8.1q-2.688,6.648-5.363,13.3c-2.5,6.241-4.563,11.416-6.481,16.286-1.124,2.861-1.972,3.367-3.335,3.374-1.407,0-2.228-.478-3.356-3.316q-5.084-12.762-10.2-25.509l-3.069-7.661a8.17,8.17,0,0,0-2.4-3.532l-3.973-3.331-1.117,10.6q-.7,6.627-1.386,13.259c-.245,2.431-.475,4.862-.7,7.293-.265,2.8-.53,5.606-.82,8.406-.349,3.374-1.854,3.766-2.955,3.766q-.123,0-.252-.007a2.523,2.523,0,0,1-1.844-.749,4.427,4.427,0,0,1-.634-3.216c1.028-11.144,2.159-22.477,3.253-33.437,0,0,.941-9.429,1.289-12.957.116-1.17.239-2.34.362-3.51.239-2.279.511-4.86.71-7.36.281-3.553,1.3-4,2.6-4.221a4.322,4.322,0,0,1,.689-.063c.629,0,1.8,0,3.053,3.153q7.882,19.822,15.816,39.624l.935,2.338c.271.672.569,1.322.913,2.069,0,0,.428.926.616,1.345l2.659,5.9,15.307-38.137c1.8-4.476,3.593-8.955,5.353-13.446,1.116-2.849,2.345-2.849,2.936-2.849a4.185,4.185,0,0,1,.66.055c1.22.191,2.257.617,2.586,3.905,0,0,4.595,45.816,5.561,55.471.095.943.143,1.774.146,2.541.008,1.546-.427,3.419-2.543,3.562C12097.034,7441.469,12096.943,7441.472,12096.854,7441.472Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_90"
                          data-name="Path 90"
                          d="M12013.069,7441.521a4.609,4.609,0,0,1-3.242-2.136c-4.2-5.456-9.055-11.81-13.593-18.176a8.094,8.094,0,0,0-7.062-3.713c-.173,0-.349,0-.528.01-1.375.057-2.88.083-4.739.083-1.135,0-2.281-.009-3.449-.018-1.319-.012-2.6-.023-3.908-.023h-2.757l.007,7.624c.006,3.738.012,7.268-.03,10.83a13.076,13.076,0,0,1-.384,3.674,2.166,2.166,0,0,1-2.36,1.759c-.147,0-.3-.008-.454-.021a2.352,2.352,0,0,1-2.357-2.167,13.7,13.7,0,0,1-.158-2.663v-.264q-.019-27.546,0-55.093c0-4.944.4-5.344,5.261-5.344h.757q3.527,0,7.058-.017l.71,0q3.166-.012,6.328-.015c5.6,0,9.87.052,13.86.168a20.456,20.456,0,0,1,18.347,13.334c3,8.471.909,17.133-5.458,22.6a38.3,38.3,0,0,1-6.382,4.085c-1.2.669-2.428,1.348-3.678,2.108l-2.59,1.573,1.813,2.432c.8,1.073,3.117,4.154,3.117,4.154,2.405,3.2,4.893,6.511,7.314,9.839,2.075,2.855.684,4.179.227,4.613A2.387,2.387,0,0,1,12013.069,7441.521Zm-39.122-29.749h2.757c2.607,0,5.18.016,7.722.032s5,.031,7.436.031c3.8,0,6.923-.038,9.82-.12a15.027,15.027,0,0,0-.131-30.023c-1.777-.07-3.741-.1-6.176-.1-1.056,0-2.111.006-3.167.013l-.789,0c-1.043.007-2.085.013-3.128.013h-14.344Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_91"
                          data-name="Path 91"
                          d="M11922.978,7441.588c-17.875,0-32.978-15.049-32.98-32.864a33.5,33.5,0,0,1,22.248-31.1,31.758,31.758,0,0,1,10.524-1.775,32.892,32.892,0,0,1,25.4,11.931c1.7,2.1,1.67,3.229,1.068,4.373a2.048,2.048,0,0,1-1.92,1.267,5.222,5.222,0,0,1-3.122-1.352c-.564-.46-1.127-.934-1.692-1.408l-.228-.191c-3.154-2.653-6.417-5.4-10.32-6.983a25.331,25.331,0,0,0-9.56-1.883c-9.769,0-18.822,5.678-23.627,14.819-6.127,11.661-2.488,26.446,8.463,34.391a26.1,26.1,0,0,0,15.436,4.951,27.263,27.263,0,0,0,19.528-8.25l.612-.641c.617-.648,1.165-1.222,1.731-1.744a3.865,3.865,0,0,1,2.478-1.21,2.57,2.57,0,0,1,1.688.731c1.174,1.038,1.211,2.717.09,4.179a31.927,31.927,0,0,1-17.728,11.729A32.338,32.338,0,0,1,11922.978,7441.588Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_92"
                          data-name="Path 92"
                          d="M11898.863,7303.639c-3.656,0-7.459-.037-11.3-.11a4.015,4.015,0,0,1-2.74-.941,2.534,2.534,0,0,1-.784-1.984c.043-2.189,2.067-2.695,3.76-2.735,1.428-.034,2.856-.044,4.285-.044,1.164,0,2.328.007,3.493.014,1.129.007,2.255.013,3.384.014h.119q1.689,0,3.38-.015l.366,0c.992-.006,1.985-.012,2.978-.012,1.666,0,3.034.016,4.309.052,2.261.063,3.441.958,3.509,2.656a2.679,2.679,0,0,1-.673,2,3.7,3.7,0,0,1-2.692.988C11906.531,7303.6,11902.7,7303.639,11898.863,7303.639Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_93"
                          data-name="Path 93"
                          d="M11994.632,7303.635c-3.743,0-7.511-.041-11.2-.123a3.638,3.638,0,0,1-2.646-.942,2.763,2.763,0,0,1-.649-2.068c.03-.695.11-2.539,3.521-2.627,1.468-.038,2.938-.05,4.407-.05,1.241,0,2.484.009,3.726.017l3.633.017q1.459,0,2.92-.013l.371,0q1.629-.012,3.253-.015c1.694,0,3.071.018,4.334.058,1.016.032,3.379.364,3.408,2.74.019,1.648-1.316,2.83-3.246,2.874C12002.548,7303.59,11998.567,7303.635,11994.632,7303.635Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_94"
                          data-name="Path 94"
                          d="M12042.81,7303.619c-3.846,0-7.8-.05-11.757-.149a3.156,3.156,0,0,1-2.286-.973,2.642,2.642,0,0,1-.7-1.975c.142-2.092,1.877-2.584,3.307-2.63,1.313-.041,2.725-.06,4.446-.06q1.749,0,3.5.016c1.181.01,2.36.019,3.542.019s2.359-.009,3.54-.018,2.339-.017,3.5-.017c1.71,0,3.122.019,4.445.06,2.786.086,3.188,1.5,3.246,2.555a2.9,2.9,0,0,1-.641,2.18,3.033,3.033,0,0,1-2.207.829C12050.825,7303.564,12046.806,7303.619,12042.81,7303.619Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_95"
                          data-name="Path 95"
                          d="M11947.2,7303.639c-3.973,0-7.989-.047-11.943-.14-1.972-.046-3.229-1.179-3.2-2.887.037-2.286,2.151-2.691,3.409-2.728,1.314-.039,2.731-.057,4.456-.057,1.138,0,2.276.008,3.415.015s2.3.016,3.454.016h.167q1.692,0,3.385-.016c1.158-.007,2.314-.015,3.472-.015,1.654,0,3.019.016,4.292.05,3.4.092,3.476,1.947,3.5,2.645a2.745,2.745,0,0,1-.659,2.044,3.667,3.667,0,0,1-2.668.955C11954.565,7303.6,11950.837,7303.639,11947.2,7303.639Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_96"
                          data-name="Path 96"
                          d="M12084.241,7303.618c-1.589,0-2.9-.018-4.122-.054-3.484-.1-3.936-1.61-3.939-2.912,0-.892-.009-2.747,3.891-2.785q5.407-.053,10.813-.052,5.442,0,10.881.051c1.819.016,3.985.513,3.978,2.788-.008,2.309-2.2,2.857-4.037,2.909-1.222.035-2.532.053-4.125.053-1.095,0-2.188-.008-3.284-.016-1.114-.008-2.222-.015-3.328-.015-1.055,0-2.063.006-3.068.014l-.648,0C12086.247,7303.611,12085.244,7303.618,12084.241,7303.618Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_97"
                          data-name="Path 97"
                          d="M11820.751,7363.5l-10.074.015q-3.442,0-6.882-.029c-1.686-.018-3.715-.505-3.806-2.725a2.463,2.463,0,0,1,.669-1.872,4.254,4.254,0,0,1,3.09-1.09q8.48-.057,16.959-.054t16.965.046c3.858.023,3.867,2.1,3.87,2.877,0,.761.012,2.783-3.845,2.82q-3.343.031-6.687.028C11829.3,7363.521,11820.751,7363.5,11820.751,7363.5Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_98"
                          data-name="Path 98"
                          d="M11820.07,7303.626c-5.812,0-11.092-.026-16.141-.079a4.187,4.187,0,0,1-3.56-1.5,2.534,2.534,0,0,1-.112-2.408c.45-1.1,1.164-1.79,3.324-1.79l17.518,0c1.543,0,8.469-.021,10-.021,2.142,0,4.28.007,6.42.032,3.978.045,4.022,1.983,4.038,2.714a2.563,2.563,0,0,1-.628,1.948,4.9,4.9,0,0,1-3.441,1.039Q11828.78,7303.619,11820.07,7303.626Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_99"
                          data-name="Path 99"
                          d="M11820.931,7411.64c-5.468,0-11.128-.02-16.827-.061a4.924,4.924,0,0,1-3.489-1.127,2.365,2.365,0,0,1-.617-1.822c.027-.667.108-2.7,4.152-2.753q3.384-.045,6.772-.04c1.493,0,5.226.011,5.226.011q2.562.009,5.116.012c1.732,0,3.367-.006,5-.013l.611,0q2.134-.01,4.269-.01c2.175,0,4.35.011,6.525.048,3.9.067,3.9,2.147,3.895,2.829,0,.775-.008,2.832-3.9,2.863C11832.283,7411.618,11826.652,7411.64,11820.931,7411.64Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_100"
                          data-name="Path 100"
                          d="M11820.967,7435.684c-5.568,0-11.386-.023-17.289-.07-1.089-.009-3.627-.3-3.677-2.86a2.338,2.338,0,0,1,.615-1.771,4.663,4.663,0,0,1,3.252-1.049q3.415-.037,6.831-.032c1.713,0,8.864.017,10.293.017,1.375,0,8.649-.018,10.069-.018q3.354,0,6.705.032c3.258.034,3.731,1.432,3.78,2.645a2.688,2.688,0,0,1-.646,2.064,4.063,4.063,0,0,1-2.959.971C11832.325,7435.66,11826.613,7435.684,11820.967,7435.684Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_101"
                          data-name="Path 101"
                          d="M11820.543,7459.608l-9.94.014q-3.245,0-6.488-.027c-1.5-.013-4.035-.394-4.112-2.79a2.365,2.365,0,0,1,.616-1.817,4.954,4.954,0,0,1,3.5-1.1q8.443-.027,16.887-.028,8.354,0,16.7.031c3.832.016,3.833,2.073,3.833,2.848s0,2.807-3.874,2.85q-3.425.04-6.849.034C11829.107,7459.625,11822.258,7459.608,11820.543,7459.608Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_102"
                          data-name="Path 102"
                          d="M11810.628,7387.536q-3.256,0-6.514-.033c-4.033-.044-4.1-2.074-4.124-2.741a2.373,2.373,0,0,1,.635-1.816,4.962,4.962,0,0,1,3.512-1.142q7.182-.05,14.364-.044,8.476,0,16.951.031l1.91.006a7.65,7.65,0,0,1,2.261.32,2.356,2.356,0,0,1,1.849,2.967c-.188,1.608-.9,2.278-2.453,2.312-2.265.05-4.713.073-7.7.073-1.793,0-3.587-.008-5.379-.015s-3.6-.017-5.4-.017h-2.757v.085S11812.276,7387.536,11810.628,7387.536Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_103"
                          data-name="Path 103"
                          d="M11814.811,7327.625c-3.7,0-7.518-.032-11.335-.093a3.879,3.879,0,0,1-2.794-1.053,2.506,2.506,0,0,1-.692-1.88c.078-2.215,2.112-2.713,3.807-2.741,1.42-.023,2.843-.031,4.264-.031,1.026,0,7.191.02,7.191.02q1.642,0,3.282-.011t3.252-.01c1.45,0,2.9.009,4.35.043,3.334.079,3.393,2.041,3.411,2.685a2.761,2.761,0,0,1-.656,2.043,3.761,3.761,0,0,1-2.708.929C11822.46,7327.591,11818.635,7327.625,11814.811,7327.625Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_104"
                          data-name="Path 104"
                          d="M11807.729,7495.577c-1.437,0-2.875-.013-4.312-.05-1.015-.026-3.381-.346-3.43-2.733a3.008,3.008,0,0,1,3.211-2.9c3.842-.085,7.824-.128,11.837-.128,3.746,0,7.513.037,11.193.111a3.672,3.672,0,0,1,2.657.926,2.8,2.8,0,0,1,.653,2.079c-.026.7-.1,2.567-3.458,2.642-1.49.035-2.98.045-4.47.045q-1.531,0-3.061-.011l-.447,0q-1.765-.01-3.534-.013c-1.2,0-2.328.007-3.46.014l-.382,0C11809.728,7495.571,11808.729,7495.577,11807.729,7495.577Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">CRM</div>
                </div>
              </Link>

              <Link to="/development/content-management-system">
                <div
                  className={
                    accuratePath === "/development/content-management-system" ||
                      accuratePath ===
                      "/development/content-management-system/umbraco" ||
                      accuratePath ===
                      "/umbraco" ||
                      accuratePath ===
                      "/development/content-management-system/kentico" ||
                      accuratePath ===
                      "/development/content-management-system/Nop-commerce" ||
                      accuratePath ===
                      "/development/content-management-system/shopify" ||
                      accuratePath ===
                      "/development/content-management-system/Big-commerce" ||
                      accuratePath === "/bigcommerce-website-development-services" ||
                      accuratePath ===
                      "/development/content-management-system/magento" ||
                      accuratePath ===
                      "/development/content-management-system/Woo-commerce" ||
                      accuratePath ===
                      "/wordpress" ||
                      accuratePath ===
                      "/development/content-management-system/wordpress"
                      ? "item we-deals-list-inner active"
                      : "item we-deals-list-inner"
                  }
                  id="6"
                  onClick={() => setSubActive(0)}
                >
                  <div className="wdi-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="315.34"
                      height="260"
                      viewBox="0 0 315.34 260"
                      onMouseOver={() => dispatch(increment())}
                      onMouseLeave={() => dispatch(decrement())}
                    >
                      <g
                        id="Group_17"
                        data-name="Group 17"
                        transform="translate(-12248.884 -7272.714)"
                      >
                        <path
                          id="Path_83"
                          data-name="Path 83"
                          d="M12558.477,7407.006c-25.55-.063-50.366-.072-71.272-.072l-54.387.012c-.183,0-.363,0-.546-.008-2.531-.081-4.111-1.415-4.123-3.48-.013-2.093,1.557-3.458,4-3.477q4.85-.036,9.7-.032c2.15,0,19.577.014,19.577.014l-.242-3c-1.909-23.958-22.826-48.74-54.523-48.74-.325,0-.647,0-.977.008-34.616.554-52.521,29.436-53.723,48.782l-.184,2.95,26.739,0c.325,0,.649,0,.976-.01.3,0,.6-.01.894-.01.537,0,.939.016,1.308.052a3.457,3.457,0,0,1,.055,6.9,10.709,10.709,0,0,1-1.263.059l-1.532-.014-124.094,0c-5.921,0-5.954-2.247-5.973-3.453a2.822,2.822,0,0,1,.687-2.151c.872-.886,2.8-1.374,5.426-1.375h20.817v-15.249c0-3.468,0-7.786.933-8.732.917-.928,4.987-.938,8.578-.947.666,0,1.387.051,2.085.1.848.058,1.672.114,2.5.114a8.648,8.648,0,0,0,4.883-1.226c2-1.352,2.578-3.76,3.087-5.885a16.341,16.341,0,0,1,.689-2.383c2.726-6.377,5.211-11.949,7.6-17.034.792-1.69,1.54-4.221-1.1-6.7-2.761-2.584-5.411-5.3-7.891-7.866-2.245-2.321-2.234-3.954.042-6.24,10.646-10.7,21.658-21.715,33.668-33.676,1.225-1.22,2.318-1.838,3.251-1.838.965,0,2.112.654,3.41,1.947,2.1,2.095,4.2,4.281,6.051,6.211q1.217,1.272,2.294,2.386l1.283,1.326,7.477-2.9c6.983-2.708,13.578-5.265,20.183-7.941a6.006,6.006,0,0,0,3.239-4.937c.106-2.321.093-4.635.08-6.873-.009-1.393-.016-2.787.006-4.179.054-3.6,1.168-4.7,4.771-4.707q11.952-.016,23.9-.016,11.7,0,23.407.017c3.55,0,4.647,1.122,4.7,4.779.021,1.436.015,2.872.009,4.307-.01,2.079-.021,4.435.066,6.727.06,1.511,1.038,4,3.035,4.8,6.773,2.726,13.538,5.345,20.7,8.116l7.233,2.8,1.282-1.331c.595-.617,2.361-2.468,2.361-2.468,1.831-1.918,3.906-4.091,5.986-6.166,1.263-1.261,2.382-1.9,3.331-1.9s2.063.636,3.325,1.89c11.593,11.539,22.847,22.793,33.452,33.448,2.512,2.523,2.5,4.088-.055,6.7-1.78,1.82-3.58,3.622-5.379,5.423q-1.591,1.59-3.176,3.184l-1.27,1.28.294.761a2.837,2.837,0,0,0,.237,1.274l.736,1.645h.158l1.333,3.441c2.592,6.7,5.271,13.624,8.054,20.537.794,1.976,3.3,2.943,4.833,3,1.685.063,3.34.071,4.593.071l4.227-.011c.736,0,1.473,0,2.207.013,3.624.051,4.734,1.159,4.754,4.744.021,3.889.018,7.779.012,11.831l-.006,8.33h11.506c.93,0,1.859.016,2.791.033l.292.006c.964.018,1.927.036,2.891.036,1.5,0,2.754-.043,3.948-.133.276-.022.546-.033.807-.033a5.037,5.037,0,0,1,4.72,2.455v2.236c-1.172,1.754-2.8,2.444-5.7,2.444Zm-275.427-7.245h61.131l.293-2.447a63.376,63.376,0,0,1,20.09-39.8,62.336,62.336,0,0,1,39.559-16.27q1.373-.056,2.729-.056a59.885,59.885,0,0,1,36.314,12c14.544,10.749,23.091,25.58,25.4,44.085l.3,2.434h61.269v-17.687l-9.96.013c-1.484,0-2.96-.005-4.437-.02-3.2-.03-4.039-.657-4.729-3.527a110,110,0,0,0-12.961-31.3c-1.555-2.566-1.41-3.6.813-5.827,1.871-1.874,3.781-3.688,5.628-5.443.829-.787,1.6-1.519,2.337-2.227l2.04-1.957-30.514-30.723-1.972,2.055c-.681.712-2.2,2.315-2.2,2.315-1.688,1.779-3.436,3.619-5.211,5.4-1.508,1.511-2.512,2.157-3.354,2.157a7.837,7.837,0,0,1-3.489-1.409,106.781,106.781,0,0,0-30.166-12.428c-3.451-.821-3.972-1.515-3.992-5.3-.013-2.443-.01-4.887-.007-7.326l0-6.588h-42.85l0,6.408c.006,2.62.01,5.18-.009,7.739-.027,3.485-.57,4.227-3.628,4.967a110.973,110.973,0,0,0-31.279,12.977,5.644,5.644,0,0,1-2.66,1c-.326,0-1.189,0-2.94-1.726-1.906-1.879-3.79-3.829-5.611-5.715l-2.493-2.574-1.964-2.015-27.439,27.419h-.7l-.721,1.688a2.949,2.949,0,0,0,.6,3.16c.846.867,2.879,2.937,2.879,2.937,1.745,1.777,3.489,3.551,5.214,5.344,2.052,2.139,2.182,3.194.7,5.646a109.387,109.387,0,0,0-12.973,31.3c-.7,2.911-1.53,3.547-4.694,3.578q-2.229.023-4.464.021l-9.883-.013Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_84"
                          data-name="Path 84"
                          d="M12448.082,7528.906a3.219,3.219,0,0,1-3.153-2.383,15.637,15.637,0,0,1-.313-3.66q-.031-21.442-.019-42.887V7463.53l-4.563-1.3-1.107,1.765-.476.745c-.383.594-.778,1.208-1.146,1.858l-3.815,6.8c-6.042,10.756-12.889,22.95-19.441,34.714-1.408,2.528-2.408,3.386-3.962,3.4-1.379,0-2.424-.525-3.965-3.3-5.983-10.749-12.047-21.539-17.909-31.974l-5.355-9.534c-.352-.622-.715-1.234-1.078-1.847l-1.543-2.613-4.738,1.161v36.611l.007,6.966c.01,5.6.021,11.941-.041,18.072-.019,2.08-.923,3.3-2.759,3.717a3.785,3.785,0,0,1-.833.093,3.021,3.021,0,0,1-2.83-1.7,7.175,7.175,0,0,1-.491-2.785c-.042-29.434-.035-58.646-.022-83.34,0-3.479,1.758-4,2.335-4.166a4.5,4.5,0,0,1,1.244-.2c.81,0,2.035.264,3.321,2.548q10.406,18.48,20.778,36.981l9.568,17.044c.372.662.759,1.315,1.2,2.061l3.168,5.394,15.182-27.039q9.362-16.683,18.729-33.365l.232-.416a14.448,14.448,0,0,1,1.167-1.884,2.982,2.982,0,0,1,2.457-1.3,4.587,4.587,0,0,1,1.315.211,2.945,2.945,0,0,1,2.286,2.86,15.853,15.853,0,0,1,.062,1.6q.006,41.358,0,82.718a14.24,14.24,0,0,1-.076,1.822,3.379,3.379,0,0,1-3.122,2.974C12448.275,7528.9,12448.178,7528.906,12448.082,7528.906Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_85"
                          data-name="Path 85"
                          d="M12316.175,7530c-2.145,0-4.468-.033-7.1-.1-13.152-.341-22.87-10.125-23.109-23.264-.1-5.459-.073-11.028-.05-16.414,0,0,.017-3.308.021-4.891l.438,0v-2.76c0-2.821-.066-5.681-.129-8.448l0-.207a162.085,162.085,0,0,1,.294-18.912c1.013-10.643,10.548-19.108,21.708-19.269l2.269-.037c1.831-.033,3.668-.065,5.5-.065a71.787,71.787,0,0,1,11.691.787c9.9,1.66,17.731,11.144,17.83,21.592.017,1.863-.529,4.106-3.228,4.205l-.216,0c-2.056,0-3.248-1.329-3.52-3.948-1.037-10.04-7.154-15.6-17.224-15.643l-1.146,0q-2.739-.014-5.48-.018c-1.775,0-3.551.008-5.325.033-9.386.127-16.281,6.758-16.4,15.767-.215,16.735-.211,33.2.012,48.934.124,8.755,6.794,15.308,15.86,15.579,2.248.067,4.565.1,6.886.1,2.156,0,4.423-.03,6.736-.089,8.9-.231,15.346-6.34,16.034-15.2.226-2.917,1.244-3.821,2.7-4.283a3.456,3.456,0,0,1,1.029-.165c1.838,0,3.25,1.671,3.284,3.888.171,11.473-9.655,22.051-21.03,22.635C12321.91,7529.934,12319.181,7530,12316.175,7530Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_86"
                          data-name="Path 86"
                          d="M12500.381,7532.714a26.75,26.75,0,0,1-22.793-12.76c-2.566-4.24-.338-5.612.4-6.063a3.428,3.428,0,0,1,1.767-.585c1.638,0,3.1,1.876,3.821,2.994a19.718,19.718,0,1,0,21.669-29.339,30.672,30.672,0,0,0-5.263-.689l-.112-.009c-.52-.036-1.038-.073-1.552-.122-14.773-1.366-25.092-13.1-24.534-27.9.526-13.977,12.191-25.131,26.558-25.39a26.69,26.69,0,0,1,20.98,10.14,5.153,5.153,0,0,1,1.447,3.615,3.216,3.216,0,0,1-1.311,2.162,3.182,3.182,0,0,1-1.971.807c-1.115,0-2.419-.809-3.67-2.278a20.239,20.239,0,0,0-15.5-7.481,19.413,19.413,0,0,0-7.1,1.355,19.642,19.642,0,0,0-12.47,19.489,19.3,19.3,0,0,0,13.989,17.737,34.2,34.2,0,0,0,7.392,1.036c12.308.744,22.872,10.371,24.572,22.391,1.838,13-5.249,25.06-17.236,29.32a27.02,27.02,0,0,1-9.08,1.572Z"
                          fill="#9cb5d4"
                        />
                        <path
                          id="Path_87"
                          data-name="Path 87"
                          d="M12406.455,7406.913a3.538,3.538,0,0,1-3.378-3.462,3.538,3.538,0,0,1,3.464-3.472,3.544,3.544,0,0,1,3.466,3.451,3.56,3.56,0,0,1-3.461,3.484Z"
                          fill="#9cb5d4"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className="wdi-heading">CMS</div>
                </div>
              </Link>
            </Slider>

            {accuratePath === "/development/website-development" ||
              accuratePath === "/development" ||
              accuratePath ===
              "/development/website-development/CMS-based-websites" ||
              accuratePath ===
              "/development/website-development/dynamic-websites" ||
              accuratePath === "/development/website-development/static-pages" ||
              accuratePath ===
              "/development/website-development/informational-websites" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="website-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/website-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Website development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/website-development/CMS-based-websites">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          CMS Based Websites
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/website-development/dynamic-websites">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Dynamic Websites
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/website-development/static-pages">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Static Pages
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/website-development/informational-websites">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Informational Websites
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* 
                          <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Turn your ideas into reality with Kindlebit. Our certified IT team is expert in developing ASP.NET, PHP, and Web applications. Contact us to get started!."
                            />
                          </MetaTags> */}

                        {path === '/development/website-development' && (
                          <Helmet>
                            <title>Top Web Development Services by Expert Developers | Kindlebit</title>
                            <meta
                              name="keyword"
                              content="web development services, website development company"
                            />
                            <meta
                              name="description"
                              content="Build powerful websites with a trusted website development company. Get custom web development services that drive results and grow your brand. Visit us for more!"
                            />
                          </Helmet>
                        )}
                        {path === '/development' && (
                          <Helmet>
                            <title>Website Development Company | Design & Development Services</title>
                            <meta
                              name="keyword"
                              content="website development company, web design and development, web development services, web designing company sites"
                            />
                            <meta
                              name="description"
                              content="Kindlebit specializes in website design and development services. Our web experiences are high-performing, feature-packed and digitally transformative."
                            />
                          </Helmet>
                        )}

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              {" "}
                              Website development
                            </div>
                            <div className="text-para">
                              Website acts as a first place for creating online
                              presence. It is instrumental in creating awareness
                              for a business, which in turn leads to better
                              sales prospects as well as increased sales in the
                              long run without spending too much money on
                              advertising if done right. Depending upon the
                              niche of industry, websites are primarily
                              classified into CMS based websites, dynamic
                              websites, static pages and informative websites
                              where each kind of website caters to a different
                              audience and thus works on a different kind of
                              business, all together.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              CMS Based Websites
                            </div>
                            <div className="text-para">
                              CMS or Content Management Systems are tools that
                              help create websites easily. Websites created
                              using CMS can be updated really fast, as they
                              allow content to be added instantaneously without
                              changing too much or no code at all. A CMS also
                              handles the basic infrastructure of the website,
                              thus businesses can put their energy elsewhere
                              rather than maintaining the website. This is also
                              an excellent low cost solution and can be ideal
                              for small businesses to have a good online
                              presence.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Dynamic Websites
                            </div>
                            <div className="text-para">
                              A Dynamic Website (also said as an
                              information-driven site) needs programming and
                              database design. A dynamic website contains
                              information and content that changes, reckoning on
                              factors corresponding to the viewer of the site,
                              the time of the day, the time zone, or the
                              language of the country of the viewer. The content
                              of your site (text/images) is kept on a database
                              or content management system. Once the data is
                              updated or modified at intervals in the database,
                              it changes on the site. These websites provide all
                              the desired levels of functionality that could be
                              required for any business.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Static Pages</div>
                            <div className="text-para">
                              As the name suggests static pages have content
                              which does not update dynamically and remains
                              consistent throughout. Such kind of websites are
                              used for displaying portfolios, single page
                              websites, landing pages etc. These types of
                              websites are created primarily in HTML and are an
                              even more economical solution than CMS based
                              websites. However, they aren’t as customizable as
                              CMS based websites.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Informational Websites
                            </div>
                            <div className="text-para">
                              These types of websites are created with the
                              objective of disseminating information. They
                              primarily contain text however can contain audio,
                              video and other formats as well to communicate
                              information. These types of websites keep the
                              users updated with the latest trends, information
                              that is useful, delivering key messages etc. Some
                              are created with the purpose of giving information
                              about the organization thus helping the
                              organization create online presence. These types
                              of websites are updated on a regular basis to keep
                              visitors updated and require proper safeguards to
                              be installed as for some organizations they act as
                              the face of the organization.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/development/web-app-development" ||
              accuratePath ===
              "/web-application-development" ||
              accuratePath ===
              "/development/web-app-development/open-Source-development" ||
              accuratePath ===
              "/development/web-app-development/microsoft-technology-development" ||
              accuratePath ===
              "/development/web-app-development/oracle-technology-development" ||
              accuratePath ===
              "/development/web-app-development/progressive-web-app-development" ||
              accuratePath ===
              "/development/web-app-development/ecommerce-development" ||
              accuratePath ===
              "/e-commerce-development" ||
              accuratePath ===
              "/development/web-app-development/marketplace-development" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="web-application-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/web-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Web Application Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/open-Source-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Open Source Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/microsoft-technology-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Microsoft Technology Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/oracle-technology-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Oracle Technology Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/progressive-web-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Progressive Web App Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/ecommerce-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Ecommerce Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/web-app-development/marketplace-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Marketplace Development
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content=" Realize your business potential with our custom web app development services. We create scalable apps customized to your needs. Contact us today! ."
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Leading Web App Development Company for Custom Apps</title>
                          <meta
                            name="keyword"
                            content="Web App Development Company, Web App Development"
                          />
                          <meta
                            name="description"
                            content="Get scalable, secure, and high-performance web apps. Partner with a top web app development company for tailored web app development solutions."
                          />
                        </Helmet>



                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Web Application Development
                            </div>
                            <div className="text-para">
                              Web Apps are interactive web technologies based
                              applications which can run on mobile, desktop,
                              laptop etc. through a web browser. They allow
                              developers the flexibility to use these apps on
                              mobile thus decreasing the overall budgetary
                              allocation required for organizations to make
                              their apps run on smartphones. These kinds of
                              applications do not need to be downloaded to
                              provide full functionality and hence aren’t that
                              resource heavy to begin with..
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Open Source Development
                            </div>
                            <div className="text-para">
                              Open source web application development relies on
                              open source technologies to develop web apps.
                              These include PHP, MySQL, PostgreSQL, Ruby on
                              Rails at the backend whereas for the frontend
                              HTML, CSS and Javascript are used. Using open
                              source technologies provides developers as well as
                              organizations security as the source code of these
                              technologies are available for everyone to view
                              and are updated regularly.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Microsoft Technology Development
                            </div>
                            <div className="text-para">
                              Microsoft has built its own set of frameworks and
                              languages that are used for web app
                              development.These include ASP.NET, .NET which are
                              used for building different kinds of apps. As
                              these languages and frameworks have the backing of
                              Microsoft so they won’t be abandoned which is a
                              reason why clients as well as developers prefer
                              apps made using microsoft technologies.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Oracle Technology Development
                            </div>
                            <div className="text-para">
                              Oracle is known as the leading relational database
                              provider where users or an application front end
                              can directly access data objects through SQL.
                              Since Oracle is a really powerful relational
                              database it is generally used by medium to large
                              corporations to handle their workloads. Oracle
                              provides a Oracle APEX platform which allows web
                              apps to be developed in no time and this platform
                              also allows to integrate charts, graphs and
                              calendars with web apps created using Oracle
                              platform
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Progressive Web App Development
                            </div>
                            <div className="text-para">
                              Progressive Web Apps(PWAs) are apps designed to be
                              run from the web browsers however they have
                              functionalities which are similar to native apps
                              for the platform. They work on four pillars which
                              serve the customer needs which include fast,
                              reliable, installable and engaging.Since these
                              apps provide the ability to be run and installed
                              using a single code base and hence the time
                              required to build these apps is significantly
                              lesser than their native counterparts. They are
                              being developed by companies big and small as they
                              have helped companies scale and develop their apps
                              faster using web technologies.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Ecommerce Development
                            </div>
                            <div className="text-para">
                              E-commerce has become the backbone of all
                              businesses that sell products and sometimes even
                              services online. Ecommerce platform allows the
                              flexibility from selling locally to throughout the
                              nation and globally as well. Thus having a good
                              ecommerce web application is paramount and there
                              are various ecommerce builders available in the
                              form of Shopify, Woocommerce, Magento,
                              Bigcommerce, Wix etc. that help build and scale
                              beautiful ecommerce stores with different levels
                              of customization. A custom ecommerce development
                              can add further functionality as well as build
                              APIs or extensions for various platforms.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Marketplace Development
                            </div>
                            <div className="text-para">
                              To disrupt the market and be a market leader,
                              marketplace is a great way to achieve that. To
                              create the next Amazon, Airbnb, eBay etc. the
                              product should be fast and fluid. To be able to
                              handle large number of pages that are created
                              through product listings. Have a robust and strong
                              infrastructure to handle payments, store payment
                              details, transaction history, order items etc.
                              while also have good SEO practices in built thus
                              allowing various sellers leverage it; It also
                              helps the marketplace to index items accordingly
                              as per buyer intent. All these can only be
                              achieved by developers who have the experience in
                              developing marketplaces as they know the best
                              practices in designing them and can also guide
                              business owners with best design choices that
                              shall give a boost to the marketplace.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/development/mobile-app-development" ||
              accuratePath ===
              "/mobile-apps-development" ||
              accuratePath ===
              "/development/mobile-application-development/iOS-app-development" ||
              accuratePath ===
              "/development/mobile-application-development/android-app-development" ||
              accuratePath ===
              "/android-application" ||
              accuratePath ===
              "/development/mobile-application-development/IOT-applications" ||
              accuratePath ===
              "/development/mobile-application-development/hybrid-app-development" ||
              accuratePath ===
              "/development/mobile-application-development/embedded-app-development" ||
              accuratePath ===
              "/embedded-application" ||
              accuratePath ===
              "/development/mobile-application-development/wearable-app-development" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="mobile-application-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/mobile-application-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Mobile Application Development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/iOS-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          iOS app development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/android-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Android app development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/IOT-applications">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          IOT Applications
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/hybrid-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Hybrid app development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/embedded-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Embedded app development
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/mobile-application-development/wearable-app-development">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Wearable app development
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Our mobile app development team delivers custom iOS and Android apps, IOT apps, and embedded apps. Contact us now for comprehensive services."
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Cross-Platform Mobile App Development Company Experts</title>
                          <meta
                            name="keyword"
                            content="mobile application development company, cross-platform mobile app development"
                          />
                          <meta
                            name="description"
                            content="Build powerful apps with a top mobile application development company. We create seamless cross-platform mobile apps for iOS and Android users."
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Mobile Application Development
                            </div>
                            <div className="text-para">
                              As every sector embraces digitization across every
                              step of the buyer journey. They have come to rely
                              on mobile apps quite extensively as they realize
                              that users are confident in buying things right
                              from their smartphones. In fact a study by
                              emarketer shows that 90% of mobile usage time is
                              spent inside different apps. Thus businesses,
                              individuals,non profits etc. just cannot ignore
                              smartphone app development as then they would be
                              behind the technology curve and could loose
                              valuable users.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              iOS app development
                            </div>
                            <div className="text-para">
                              iOS, the operating system for the world's most
                              popular smartphone, iPhone debuted back in 2007.
                              iOS apps are designed to be exclusively run on
                              iPhones hence are highly specific and provide
                              efficient usage of all the sensors data to create
                              a wonderful experience for the users. iOS apps are
                              written on Swift, C#, Objective C, Flutter and
                              React Native (for cross platform
                              development),HTML5 (for building web applications
                              for iOS). However, Swift and C# are Apple’s choice
                              for development of apps.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Android app development
                            </div>
                            <div className="text-para">
                              Android is the world’s largest mobile operating
                              system. Due to the vast number of devices that
                              support Android, development of apps for android
                              platform has been great with an astronomical
                              number of apps being developed every year. Android
                              apps are written in Java, Kotlin, C++, C#,HTML,
                              CSS and Javascript (which are used for creating
                              web based apps), Dart (which powers Flutter
                              framework thus leading to cross platform
                              development)
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              IOT Applications
                            </div>
                            <div className="text-para">
                              IoT or Internet of Things solution connects hosts
                              of devices with one another in a way that they can
                              communicate and share information with each
                              other.This real time gathering of data is used to
                              make meaningful decisions however since these
                              devices by default do not have an interface where
                              the information collected can be displayed thus
                              apps are created where all the data collected from
                              different sources is displayed. IoT devices are
                              particularly being used in agriculture,
                              automobile, smart homes, retail, manufacturing and
                              shipping and logistics industry to improve
                              efficiency in these sectors as well as help
                              various stakeholders in more ways than one.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Hybrid app development
                            </div>
                            <div className="text-para">
                              Hybrid apps are a blend between native apps and
                              web based solutions. These apps are written on web
                              based technologies like HTML, CSS and Javascript
                              which are then put in a native app shell. Since
                              these apps are written in web technologies hence
                              allow the ability for code reuse depending upon
                              the app platform which is iOS or Android. Also,
                              they are cheaper to build and maintain than their
                              native counterparts and hence are preferred by
                              small to medium enterprises.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Embedded app development
                            </div>
                            <div className="text-para">
                              Embedded apps are specifically designed to be run
                              with embedded systems. These types of apps are
                              used to provide remote access to the embedded
                              system and are used in Industrial,Healthcare and
                              Automotive industries. These apps can be built
                              using Java, Kotlin for Android devices, Swift,
                              Objective C for iOS devices, Xamarin for hybrid
                              apps.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Wearable app development
                            </div>
                            <div className="text-para">
                              Wearables are a new category of hardwares which
                              have gained traction in the last couple of years.
                              These are smart watches which are connected to
                              smartphones who have a whole lot of sensors in
                              them which are used to achieve various kinds of
                              functionalities. Apps created for wearables
                              primarily include healthcare, fitness, business
                              and travel, sports and entertainment, lifestyle
                              and shopping, payment based apps etc. These apps
                              are coded in Swift or Kotlin depending upon the
                              platform they are being developed for.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/development/desktop-app-development" ||
              accuratePath ===
              "/development/desktop-applications/customized-intranet-applications" ||
              accuratePath ===
              "/development/desktop-applications/ERP-management-software" ||
              accuratePath ===
              "/development/desktop-applications/industrial-automation" ||
              accuratePath ===
              "/development/desktop-applications/utility-application" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="desktop-application-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/desktop-applications">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Desktop Applications
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/desktop-applications/customized-intranet-applications">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Customized Intranet Applications
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/desktop-applications/ERP-management-software">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          ERP Management Software
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/desktop-applications/industrial-automation">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Industrial Automation
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/desktop-applications/utility-application">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Utility Application
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >

                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content=" We offer customized desktop applications tailored to your specific business needs. Our services ensure optimal performance and user satisfaction. Contact us today!"
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Kindlebit | Desktop Application Development Services</title>
                          <meta
                            name="keyword"
                            content="desktop application development, desktop app development, desktop application development services, desktop app development company"
                          />
                          <meta
                            name="description"
                            content="Kindlebit offers desktop application development services. Our workflow includes planning, coding, testing, deployment, and distribution for top solutions."
                          />
                        </Helmet>

                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Desktop Applications
                            </div>
                            <div className="text-para">
                              Desktop applications interact directly with the
                              operating system of the computer rather than using
                              the web to achieve its functionality. Desktop apps
                              are generally resource heavy applications and
                              hence they generally have a lot of features built
                              in them which are generally absent in their web
                              based solution counterparts. They take longer to
                              develop however are generally more stable than the
                              web based solutions and hence don’t require
                              frequent updates like the web based ones. These
                              are classified into Customized Intranet
                              Applications, ERP Management Software, Industrial
                              Automation and Utility Application.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Customized Intranet Applications
                            </div>
                            <div className="text-para">
                              Intranet solutions power applications, data
                              between the various data points in the
                              organization. Such applications provide a way for
                              the organization to connect various verticals of
                              the organization from IT to HR correctly and
                              provide a strong security suite so that the
                              internal sensitive data of the organization does
                              not leak in the wrong hands. These apps also have
                              a level of flexibility in them thus they can be
                              scaled as per the needs of the organization.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              ERP Management Software
                            </div>
                            <div className="text-para">
                              ERP or Enterprise Resource Planning is a singular
                              software that gathers information from all the
                              departments and creates a database in a way that
                              people from a certain department can access
                              information from that particular department only.
                              Already established ERP vendors have prices
                              varying from few hundred to few thousand dollars;
                              a custom solution though would be more affordable
                              and as per the needs of the organization which
                              allows the users of the app to be more familiar
                              with the app instantaneously. A custom solution
                              also has detailed documents prepared at the
                              disposal of the organization and hence they do not
                              have to rely on a third party website to get
                              resolution to the problems of the company.
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Industrial Automation
                            </div>
                            <div className="text-para">
                              Industrial software applications support data
                              acquisition, processing, management, and control
                              of industrial-scale manufacturing processes. These
                              software application suites help identify any
                              minor faults that could creep in the manufacturing
                              processes and hence prevent major accident which
                              could hurt employees’ health as well as halt
                              production thus causing industries money. These
                              types of softwares also assist in optimal resource
                              usage and hence keep the production costs down.
                              These types of softwares are typically written in
                              C/C++
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Utility Application
                            </div>
                            <div className="text-para">
                              Utility applications are any type of applications
                              which assist the users to achieve different types
                              of use case scenarios. These can range from music
                              streaming, scientific calculators, photo or video
                              editing etc. Though there are a lot of web based
                              solutions these types of applications take full
                              advantage of the operating system and hence they
                              are generally faster than the web based solutions.
                              The web based solutions are generally no match
                              with the kind of feature set these provide. Also
                              they help keep the data private and confidential
                              as these do not require any data to be uploaded to
                              any server thus aren’t that prone to cyberattacks.
                              These types of softwares are typically written in
                              C++,.NET, Python etc. depending upon the use case
                              of the application
                            </div>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/development/customer-relationship-management" ||
              accuratePath ===
              "/development/customer-relationship-management/zoho" ||
              accuratePath ===
              "/zoho" ||
              accuratePath ===
              "/development/customer-relationship-management/salesforce" ||
              accuratePath ===
              "/development/customer-relationship-management/hubspot" ||
              accuratePath ===
              "/development/customer-relationship-management/microsoft-dynamics-365" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="desktop-application-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/customer-relationship-management">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          CRM
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/customer-relationship-management/zoho">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          ZOHO
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/customer-relationship-management/salesforce">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Salesforce
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/customer-relationship-management/hubspot">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Hubspot
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/customer-relationship-management/microsoft-dynamics-365">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Microsoft Dynamics 365
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">

                          <Helmet>
                            <title>CRM Solutions for Customer & Client Relationship Management</title>
                            <meta
                              name="keyword"
                              content="customer relationship management, client relationship management, customer resource management, crm relationship management"
                            />
                            <meta
                              name="description"
                              content="Optimize your business with CRM relationship management solutions. Enhance customer and client relationship management and improve interactions for success."
                            />
                          </Helmet>

                          <div className="ipc">
                            <div className="sap-md-heading">CRM</div>
                            <div className="text-para">
                              CRM or customer relationship manager is a
                              technology software that helps manage a company's
                              relationship with current customers and potential
                              customers. A CRM allows combining all
                              communications from mails, calls, texts, form
                              fills, meetings, messages etc. thus allowing for a
                              smooth operation and organization within the
                              company as well as outreach to current and
                              potential customers. The data in a CRM gets
                              automatically updated depending upon the action
                              taken by users which wouldn’t have been possible
                              in a spreadsheet hence CRM plays an integral role
                              in company’s growth as well. There are many
                              different types of CRM however the industry
                              leading being ZOHO, Salesforce, Microsoft Dynamic
                              365.
                            </div>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">ZOHO</div>
                            <div className="text-para">
                              Zoho is a web-based online CRM office suite that
                              offers its users various features and
                              functionalities such as databases, word
                              processing, spreadsheets, wikis, web conferencing,
                              and much more that helps business by easing its
                              business workings. As a CRM, ZOHO can be heavily
                              customized as per the organization’s needs and
                              ZOHO development includes:
                            </div>
                            <ul>
                              <li>Industry Specific ZOHO Development</li>
                              <li>ZOHO CRM Development</li>
                              <li>Database building</li>
                              <li>ZOHO Customization</li>
                              <li>ZOHO web application development</li>
                              <li>ZOHO creator web and mobile app building</li>
                              <li>REST API integration and development</li>
                              <li>ZOHO rapid application development</li>
                              <li>ZOHO integration with third party apps</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Salesforce</div>
                            <div className="text-para">
                              Salesforce is one of the biggest CRMs in the
                              market. Like ZOHO it provides a host of
                              functionalities such as databases, word
                              processing, spreadsheets, wikis, web conferencing
                              etc. which allows teams from various departments
                              from IT, marketing, sales, commerce and services
                              to interact with one another and provide an
                              engaging experience to the user. Salesforce
                              development includes:
                            </div>
                            <ul>
                              <li>Salesforce lightning development</li>
                              <li>
                                Salesforce lightning web component (LWC)
                                development
                              </li>
                              <li>Salesforce community development</li>
                              <li>
                                Salesforce lightning external apps development
                              </li>
                              <li>Salesforce CPQ</li>
                              <li>
                                Salesforce app exchange product development
                              </li>
                              <li>Salesforce mobile app development</li>
                              <li>Salesforce Heroku development</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Hubspot</div>
                            <div className="text-para">
                              Hubspot provides a one stop solution from
                              designing, developing a website to linking them to
                              Hubspot’s CRM which takes care of email tracking,
                              mail scheduler, meeting scheduler, document
                              sharing etc. all these features assist businesses
                              in getting a complete package that can assist them
                              in every step of the chain from development to
                              sales to support. Our Hubspot development services
                              include:
                            </div>
                            <ul>
                              <li>Hubspot Template Development</li>
                              <li>Hubspot Landing Page Development</li>
                              <li>Hubspot Website Development</li>
                              <li>Hubspot Ecommerce development</li>
                              <li>Hubspot Plugin development</li>
                              <li>Custom Hubspot development</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Microsoft Dynamics 365
                            </div>
                            <div className="text-para">
                              Microsoft Dynamics 365 is a CRM solution by
                              Microsoft whose feature set is similar to ZOHO and
                              Salesforce. What makes Microsoft Dynamics standout
                              is readily integration with Microsoft products
                              including a very powerful LinkedIn Sales navigator
                              something which no other CRM provides. Dynamic 365
                              also provides integration with Power BI to analyze
                              the data gathered. Our Microsoft Dynamics 365
                              services include:
                            </div>
                            <ul>
                              <li>
                                Consulting : providing the right microsoft 365
                                solution for your company depending upon your
                                use case.
                              </li>
                              <li>
                                Implementation: creating tailor made apps for
                                which can leverage the power of microsoft
                                dynamics 365 for your business.
                              </li>
                              <li>CRM Migration</li>
                              <li>
                                Hubspot Ecommerce developmentCRM Integration:
                                Integrating CRM with your family of apps that
                                you use to get best value for your
                                business.Hubspot Plugin development
                              </li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}

            {accuratePath === "/development/content-management-system" ||
              accuratePath === "/development/content-management-system/umbraco" ||
              accuratePath ===
              "/umbraco" ||
              accuratePath === "/development/content-management-system/kentico" ||
              accuratePath ===
              "/development/content-management-system/Nop-commerce" ||
              accuratePath === "/development/content-management-system/shopify" ||
              accuratePath ===
              "/development/content-management-system/Big-commerce" ||
              accuratePath === "/bigcommerce-website-development-services" ||
              accuratePath === "/development/content-management-system/magento" ||
              accuratePath ===
              "/development/content-management-system/Woo-commerce" ||
              accuratePath ===
              "/wordpress" ||
              accuratePath ===
              "/development/content-management-system/wordpress" ? (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.3 }}
                className="sap-tab-vert d-flex align-items-start"
                id="desktop-application-development"
              >
                <Tabs
                  selectedIndex={subActive}
                  onSelect={(index) => setSubActive(index)}
                >
                  <TabList className="nav flex-column nav-pills me-3 react-tabs__tab-list">
                    <Tab>
                      <Link to="/development/content-management-system/sitefinity">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Sitefinity
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/umbraco">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Umbraco
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/kentico">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Kentico
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/Nop-commerce">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Nopcommerce
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/shopify">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Shopify/ Shopify Plus
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/Big-commerce">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Bigcommerce
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/magento">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Magento 2
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/Woo-commerce">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          Woo-commerce
                        </div>
                      </Link>
                    </Tab>

                    <Tab>
                      <Link to="/development/content-management-system/wordpress">
                        <div
                          className="sap-sm-heading"
                          onMouseOver={() => dispatch(increment())}
                          onMouseLeave={() => dispatch(decrement())}
                        >
                          WordPress
                        </div>
                      </Link>
                    </Tab>
                  </TabList>
                  <div className="tab-content">
                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        {/* <MetaTags>
                            <meta
                              id="meta-description"
                              name="description"
                              content="Kindlebit Solutions can simplify your content management process. Our expert team builds user-centric CMS solutions. Contact us right now!"
                            />
                          </MetaTags> */}
                        <Helmet>
                          <title>Sitefinity Web Developer & Content Management System</title>
                          <meta
                            name="keyword"
                            content="sitefinity cms, sitefinity content management system, sitefinity web developer, sitefinity cms partner"
                          />
                          <meta
                            name="description"
                            content="Sitefinity CMS is a powerful content management system offering smart tools for marketers. Partner with a Sitefinity web developer for enhanced performance."
                          />
                        </Helmet>


                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Sitefinity</div>
                            <div className="text-para">
                              Sitefinity is a full featured enterprise CMS that
                              has been built around the principles of
                              extensibility, interoperability and flexibility.
                              Sitefinity’s user interface is very easy to use
                              and task-focused. The interface can be freely
                              organized and tailored to suit every user and
                              role. Sitefinity also allows creating web apps
                              using ASP.NET MVC thus allowing complete benefit
                              of Windows authentication, caching master pages
                              etc. It also allows the creation of robust mobile
                              optimized websites in a remarkably easy manner.
                              Advantages of Sitefinity are:
                            </div>
                            <ul>
                              <li>Based on .NET</li>
                              <li>Rich content editor</li>
                              <li>Inbuilt SEO tools</li>
                              <li>Website and Mobile development</li>
                              <li>Third party integration</li>
                              <li>Form builder</li>
                              <li>Drag and drop facility</li>
                              <li>24*7 online tech community support</li>
                            </ul>
                            Thus making an ideal bet for creating a CMS which
                            can handle enterprise data easily and efficiently.
                            <ul>
                              <li>Sitefinity consultation</li>
                              <li>Software development and customization</li>
                              <li>Customized modules and widgets</li>
                              <li>Migration from other CMS</li>
                              <li>Client facing portals</li>
                              <li>Maintenance and support</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Umbraco</div>
                            <div className="text-para">
                              Umbraco an open source CMS written in C# is a
                              completely customizable content management system.
                              Umbraco allows a heavy level of customization
                              however it does require good knowledge of
                              programming language to be customized, something
                              which isn’t true for some other CMS. Umbraco which
                              is based on the .NET platform uses code access
                              security which means it is more secure than most
                              of the basic CMS out in the market. It also allows
                              easier integration with Microsoft products like
                              Microsoft Word and Microsoft CRM.Our Umbraco
                              services include:
                            </div>
                            <ul>
                              <li>Umbraco CMS design and development</li>
                              <li>Performance analysis and web statistics</li>
                              <li>WCF development</li>
                              <li>SQL development</li>
                              <li>Umbraco theme customization</li>
                              <li>Maintenance and support</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Kentico</div>
                            <div className="text-para">
                              Kentico is web based CMS written in C# which uses
                              ASP.NET and Microsoft SQL Server for development.
                              Kentico provides an inbuilt email marketing tool
                              along with an A/B tester thus developers as well
                              as marketers know what type of content is
                              converting and hence can alter their content
                              accordingly. It also provides an inbuilt lead
                              scoring capability which allows assessing the
                              leads and giving them a numerical value which is
                              used to give indicator whether a certain lead
                              would convert or not. Our Kentico services
                              include:
                            </div>
                            <ul>
                              <li>Website development services</li>
                              <li>Kentico eCommerce solutions</li>
                              <li>Kentico Intranet development</li>
                              <li>Custom Kentico plugin development</li>
                              <li>Kentico support and maintenance</li>
                              <li>Kentico marketing automation services</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Nopcommerce</div>
                            <div className="text-para">
                              Nopcommerce is a free and open source ecommerce
                              platform which has been built on ASP.NET Core
                              which can be integrated with small and medium
                              business, enterprise business and global business.
                              It provides easy drop shipping with multi vendor
                              ecommerce and allows managing multiple stores with
                              a single admin panel. Also, Nopcommerce has
                              already built in compliance with PCI DSS thus
                              making it an ideal solution for ecommerce stores.
                              Our Nopcommerce development services include:
                            </div>
                            <ul>
                              <li>Ecommerce store development</li>
                              <li>Custom feature and module development</li>
                              <li>Theme and template design</li>
                              <li>Integration and upgradation</li>
                              <li>Migration to Nopcommerce</li>
                              <li>Support and maintenance</li>
                              <li>Shipping module integration</li>
                              <li>Secure payment gateway support</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">
                              Shopify/ Shopify Plus
                            </div>
                            <div className="text-para">
                              Shopify is the world’s no 1 ecommerce platform
                              with more than 80% of ecommerce websites created
                              on shopify exclusively. Shopify integrates your
                              store with ecommerce store and POS as well thus
                              providing a complete solution to selling products.
                              Shopify allows creating apps, themes, storefronts
                              and marketplaces thus taking care of every
                              ecommerce need. Shopify Plus is the ecommerce
                              platform exclusively catering to larger
                              organizations as it allows greater features than
                              shopify and even allows extra features such as
                              enhanced online retail experience through AR, VR
                              and 3D product pages. It also allows tweaking the
                              checkout page with custom discounts, shipping
                              rates and product recommendations. Shopify Plus
                              users also get access to Klaviyo, an email
                              marketing and automation tool which further helps
                              drive business activities. Our Shopify/Shopify
                              Plus services include:
                            </div>
                            <ul>
                              <li>Shopify store development</li>
                              <li>Shopify shop customization</li>
                              <li>Shopify theme design</li>
                              <li>Shopify custom plugins</li>
                              <li>Shopify custom theme development</li>
                              <li>TPI integration</li>
                              <li>Specific landing page development</li>
                              <li>Forum development</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Bigcommerce</div>
                            <div className="text-para">
                              BigCommerce is one of the biggest eCommerce stores
                              that today is used by numerous small businesses as
                              well as MNC’s for creating and developing their
                              BigCommerce shopping portals. BigCommerce is well
                              known for providing robust store development
                              accompanied by some great features which include:
                            </div>
                            <ul>
                              <li>
                                Native B2C and B2B with simultaneous
                                functionality
                              </li>
                              <li>
                                Enterprise B2C, B2B, multi-storefront and
                                localization
                              </li>
                              <li>Omnichannel & Commerce-as-a-Service</li>
                              <li>Open APIs, SDKs and data</li>
                              <li>
                                Composable architecture and headless commerce
                                integrations
                              </li>
                              <li>Frictionless checkout options</li>
                              <li>Abandoned cart recovery essentials</li>
                              <li>
                                99.99% uptime (including 100% cyber week 7 years
                                running)
                              </li>
                              <li>
                                Robust security: ISO/IEC 27001:2013 & PCI DSS
                                3.2, Level 1 certified
                              </li>
                              <li>
                                Actionable insights for data-driven decisioning
                              </li>
                            </ul>
                            We have Bigcommerce developer experts who can easily
                            offer you catalog management, hosting the store,
                            user management, payment integration, analytics, and
                            security integrations for your BigCommerce store.
                          </div>
                          <ul>
                            Our Bigcommerce services include:
                            <li>Bigcommerce theme customization</li>
                            <li>Bigcommerce native mobile app development</li>
                            <li>Bigcommerce API integration</li>
                            <li>
                              Bigcommerce plugin development and integration
                            </li>
                            <li>Responsive custom web design</li>
                            <li>Bigcommerce SEO and SMO</li>
                          </ul>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Magento 2</div>
                            <div className="text-para">
                              Magento, now known as Adobe Commerce, is an open
                              source ecommerce platform written in PHP. It is
                              regarded as one of the best eCommerce platforms
                              that offers flexibility, scalability and
                              attractive features to its users. Magento is used
                              by retailers as a robust system to help them scale
                              & grow their online business. Integration of
                              various extensions and solutions is what makes
                              Magento so popular among retailers. It can cater
                              to all the categories of businesses B2B, B2C, C2C
                              and C2B. Magento also provides a Commerce edition
                              which has some extra features built in over the
                              Magento open source edition but requires licensing
                              fees to be paid. Magento clearly has an advantage
                              over eCommerce solutions as it can handle 1
                              million SKUs easily and as it is an Adobe product
                              now it gets access to all the Adobe analytics. It
                              also has a robust way of handling SEO from SEO
                              friendly URLs to meta implementation across the
                              website to introduction of rich snippets to set up
                              and optimize XML sitemaps.Thus proving to be a
                              complete solution for eCommerce development. Our
                              Magento development services include:
                            </div>
                            <ul>
                              <li>Magento website design and development</li>
                              <li>Responsive Magento development</li>
                              <li>
                                Magento shopping cart and payment gateway
                                integration
                              </li>
                              <li>Custom eCommerce development</li>
                              <li>Magento theme and plugin development</li>
                              <li>Support and maintenance</li>
                            </ul>
                          </div>
                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">Woocommerce</div>
                            <div className="text-para">
                              Woocommerce is a customizable, open source
                              eCommerce platform built on WordPress, which is
                              written on PHP. As it is built on WordPress thus
                              allow integrations with a lot of plugins thus
                              allowing complete control for marketers and
                              developers to leverage these to deliver a great
                              experience to the users. Woocommerce features
                              include:
                            </div>
                            <ul>
                              <li>Create beautiful and enticing storefronts</li>
                              <li>Customize product pages</li>
                              <li>
                                Sell different kind of products and services
                              </li>
                              <li>SEO optimized webpages</li>
                              <li>Increased scalability</li>
                              <li>
                                Easy integration with Google ads, Hubspot,
                                Mailchimp and Facebook
                              </li>
                            </ul>
                            Our Woocommerce services include:
                            <ul>
                              <li>Woocommerce store development</li>
                              <li>Theme design and development</li>
                              <li>Plugin development</li>
                              <li>Data migration</li>
                              <li>Woocommerce customization</li>
                              <li>Woocommerce migration and update</li>
                              <li>Woocommerce SEO</li>
                              <li>Woocommerce maintenance</li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>

                    <TabPanel>
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div className="inner-page-con">
                          <div className="ipc">
                            <div className="sap-md-heading">WordPress</div>
                            <div className="text-para">
                              WordPress is an open source CMS platform which
                              allows drag and drop facility to create websites.
                              It is the largest used CMS and has a market share
                              of 65% among all CMS as per W3Techs this explains
                              the amount of clout WordPress has among CMS. It
                              also has a very big developer community who create
                              different plugins which can be used to get even
                              better results from WordPress. Also, sites created
                              using WordPress are easier to optimize for search
                              engines, another reason for businesses preferring
                              WordPress for creating their website. All websites
                              created using WordPress can be easily optimized
                              for mobile usage. Our WordPress services include:
                            </div>
                            <ul>
                              <li>WordPress blog development</li>
                              <li>WordPress CMS development</li>
                              <li>WordPress Website development</li>
                              <li>WordPress integration</li>
                              <li>WordPress Plugin development</li>
                              <li>WordPress hosting</li>
                              <li>
                                WordPress maintenance and technical support
                              </li>
                              <li>Custom WordPress development</li>
                              <li>Corporate blogging solutions</li>
                              <li>
                                WordPress custom theme design and development
                              </li>
                            </ul>
                          </div>

                          <div className="dual-btn">
                            <div className="sap-btn-dark">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => navigate("/portfolio")}
                              >
                                view portfolio
                              </button>
                            </div>
                            <div className="sap-btn-light">
                              <button
                                onMouseOver={() => dispatch(increment())}
                                onMouseLeave={() => dispatch(decrement())}
                                onClick={() => setCommonModal(true)}
                              >
                                call us now!
                              </button>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </TabPanel>
                  </div>
                </Tabs>
              </motion.div>
            ) : (
              ""
            )}
          </div>
        </section>
      </main>

      {/* Contact modal */}
      {commonModal && (
        <ContactModal
          commonModal={commonModal}
          setCommonModal={setCommonModal}
        />
      )}
    </>
  );
}

export default Development;
